import * as d3 from 'd3';
import React, { useEffect, useRef, useState } from 'react';

interface BodyPartInterface { 
    title:{name: string, x?: number,y?: number,},  
    Source2: string,   
    side:  string,
    position: { 
        male: {x: number,y: number,},
        female: {x: number,y: number,}
    }, 
    cellType:string,
    tissueId?: string,
    color: any,
    linkNode?: any,
    textNode?: any,
    sampleData?: any[],
    hoverRefCount?: number,
    clickRefCount?: number
};

function GiHuman(props:any) {

    const svgRef:any = useRef();

    const cloneData:any[] = props.cloneData;
    const cloneDetailData:any[] = props.cloneDetailData;

    let initData:any  = props.initialization;
    const width:number = initData.width;
    const height:number = initData.height;
    const viewbox:any = initData.viewbox;
    let sex:string = initData.sex;

    if(sex === undefined){
        sex = "male"
    }

    let organDic:any = {};

    initData.change_on_human = function(data:any, active:boolean, isClick?:boolean){


        //let bodyPartKey:string = data.detailData.tissue_id;
        let bodyPartKey:string = data.detailData.Cell_type + "_" + data.detailData.location_name
        let bodyPart:BodyPartInterface = bodyPartsDic[bodyPartKey];

        if(bodyPart !== undefined){
            // Multiple phylogram leaves (e.g. a hovered branch and a separately
            // clicked branch) can map to the same body part. Track how many are
            // currently asking for it to be active so one leaf's mouseout doesn't
            // turn off a highlight another leaf still wants on.
            //
            // Hover and click are tracked in separate counters rather than one
            // shared counter: a real click is always preceded by its own hover on
            // the same branch, so a shared counter gets incremented twice for the
            // same leaf. Re-clicking the same branch without first moving the
            // mouse away (no matching hover-out) would then only decrement once,
            // leaving the highlight stuck on even though nothing is selected or
            // hovered anymore.
            if(bodyPart.hoverRefCount === undefined){
                bodyPart.hoverRefCount = 0;
            }
            if(bodyPart.clickRefCount === undefined){
                bodyPart.clickRefCount = 0;
            }

            if(isClick){
                bodyPart.clickRefCount = Math.max(0, bodyPart.clickRefCount + (active ? 1 : -1));
            }else{
                bodyPart.hoverRefCount = Math.max(0, bodyPart.hoverRefCount + (active ? 1 : -1));
            }

            activeNodes(bodyPart.textNode
                    , bodyPart
                    , bodyPart.hoverRefCount > 0 || bodyPart.clickRefCount > 0
                    , true);

            if(bodyPart.sampleData !== undefined) {
                for(let i=0; i< bodyPart.sampleData.length; i++){
                    let sampleData: any = bodyPart.sampleData[i];

                    if(sampleData.sample_id === data.detailData.sample_id){
                        // Same hover/click split as the body part above: a clicked
                        // branch's sample circle should stay colored through mouseout,
                        // and only reset once nothing is hovering or selecting it.
                        if(sampleData.hoverRefCount === undefined){
                            sampleData.hoverRefCount = 0;
                        }
                        if(sampleData.clickRefCount === undefined){
                            sampleData.clickRefCount = 0;
                        }

                        if(isClick){
                            sampleData.clickRefCount = Math.max(0, sampleData.clickRefCount + (active ? 1 : -1));
                        }else{
                            sampleData.hoverRefCount = Math.max(0, sampleData.hoverRefCount + (active ? 1 : -1));
                        }

                        if(sampleData.hoverRefCount > 0 || sampleData.clickRefCount > 0){
                            d3.select(sampleData.sampleCircleNode).style("fill", bodyPart.color);
                        }else{
                            d3.select(sampleData.sampleCircleNode).style("fill", "black");
                        }
                    }
                }
            }
        }else{
            console.log(bodyPartKey)
            console.log(data.detailData);
        }
    }

    initData.resetOrgan = function(){
        let organKeys:string[] = Object.getOwnPropertyNames(organDic);

        organKeys.forEach((organName:string) => {
            organDic[organName].classed("organ--active", false)
        })
    }

    initData.activeOrgan = function(selectedOrganName: string, active: boolean) {
        
        let multiOrgan:any = {
            kidney: ["kidney_lt", "kidney_rt" ],
            intestine: ["small_intestine"],
            colon: ["large_intestine"],
            lung: ["lungs_rt", "lungs_lt"],
            vessel: ["venacava", "aorta"],
        };

        let organNames:string[] = multiOrgan[selectedOrganName];

        if(organNames === undefined){
            organNames = [selectedOrganName]
        }

        organNames.forEach(function(organName:string){
            if(organDic[organName]){
                organDic[organName].classed("organ--active", active)
            }
        });
        // console.log(selectedOrganNamesDic);
    }


    ///////////////////
    let selectedOrganNamesDic:any = {}
    let seletedTitleG:any;
    let seletedCircleG:any;

    ////// active organ with click from other event
    initData.resetSeletedTitle = function(){
        selectedOrganNamesDic = {};
    }

    initData.writeSeletedTitle = function(selectedOrganName: string, isSelected: boolean, title:string, color:string, x:number, y:number, strokeDasharray?:string, isClickMainTitle?: boolean){

        if(seletedTitleG === undefined ){
            seletedTitleG = d3.select(svgRef.current).append("g")
                              .attr("transform", `translate( ${labelStartPosition},${20})`);
        }

        if(seletedCircleG === undefined ){
            seletedCircleG = d3.select(svgRef.current).append("g")
        }

        seletedTitleG.selectAll("g").remove();
        seletedCircleG.selectAll("g").remove();

        if(title !== undefined){

            let organTitles:any = selectedOrganNamesDic[selectedOrganName];

            if(organTitles === undefined ){
                selectedOrganNamesDic[selectedOrganName] = {name:selectedOrganName,color: color, minY: 99999999}
                organTitles = selectedOrganNamesDic[selectedOrganName];
                organTitles.datas = {}
            }

            if(isSelected){    
                organTitles.datas[title] = {
                    title: { 
                        name: title,
                        x: labelStartPosition,
                        y: 0
                    }, 
                    color: color, 
                    position:{x: x, y: y + plotMargins.xorrectionY},
                };

                if(strokeDasharray){
                    organTitles.datas[title].strokeDasharray = strokeDasharray;
                }
                
            }else{
                delete organTitles.datas[title];
            }
        }
        
        let keys:string[] = Object.getOwnPropertyNames(selectedOrganNamesDic);


        // Sorting
        let tempSelectedData:any[] = [];
        
        keys.forEach(key => {
            let organTitlesByKey:any = selectedOrganNamesDic[key];
            tempSelectedData.push(organTitlesByKey);

            let titleKeys:string[] = Object.getOwnPropertyNames(organTitlesByKey.datas);
            let titleDatas:any[] = [];
            organTitlesByKey.titleDatas = titleDatas;

            if(titleKeys.length > 0){
                titleKeys.forEach(function(titleKey: string) {
                    titleDatas.push(organTitlesByKey.datas[titleKey]);
                });
            
                titleDatas.sort(
                    function (a, b) {
                        if (a.position.y > b.position.y) {
                            return 1;
                        } else if (a.position.y <= b.position.y) {
                            return -1;
                        } 
                        return 0;
                    }
                );
                
                organTitlesByKey.minY  = titleDatas[0].position.y;
            }
        })
        
        tempSelectedData.sort(
            function (a, b) {
                if (a.minY > b.minY) {
                    return 1;
                } else if (a.minY < b.minY) {
                    return -1;
                } else if (a.name < b.name) {
                    return -1;
                } else if (a.name > b.name) {
                    return 1;
                }
                return 0;
        });

        let index:number = 0

        tempSelectedData.forEach(organData => {
            if(organData.titleDatas && organData.titleDatas.length > 0){

                let isSelectMainTitle:boolean = false;

                let mainTitleG:any = seletedTitleG
                                            .append("g")
                                            .append("text")
                                            .attr("dx", 0)
                                            .attr("dy", 0)
                                            .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                                            .attr('font-size', '12px')
                                            .attr("fill", organData.color)
                                            .attr("font-weight", "bold")
                                            .text(organData.name)
                                            .attr("transform", function(d:any) {
                                                return `translate(${10},${(index++ * 10)})`; 
                                                })
                                            .on("click", mouseClickOnMainLabel())
                                            .on("mouseover", mouseoveredWithMainLabel(true))
                                            .on("mouseout", mouseoveredWithMainLabel(false))    
                                            .style("cursor", "pointer");               
        

                let titleG:any = seletedTitleG.append("g")
                            .selectAll("text")
                            .data(organData.titleDatas)
                            .enter()
                            .append("text")
                            .each((d:any) => { d.textNode = this;})
                            .attr("dx", 0)
                            .attr("dy", 3)
                            .attr("transform", function(d:any) {
                                let dy:number = ((index++ * 10));
                                d.title.y = dy + 20;

                                return `translate(${20},${dy})`; 
                                })
                            .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                            .attr('font-size', '10px')
                            .text(function(d:any){ 
                                return d.title.name;
                            })
                            .on("mouseover", mouseoveredWithOrganLabel(true))
                            .on("mouseout", mouseoveredWithOrganLabel(false));


                index += 2;

                let circleG:any = seletedCircleG.append("g")
                            .selectAll("circle")
                            .data(organData.titleDatas)
                            .enter()
                            .append("circle")
                            .attr("id", function(d:any) {return d.title.name})
                            .attr("stroke","#000000")
                            .attr("stroke-width", "1px")
                            .attr("fill", function(d:any) {return d.color})
                            .attr("opacity", "0.5")
                            .attr("r", 3)
                            .attr("cx", function(d:any) { return d.position.x; })
                            .attr("cy", function(d:any) { return d.position.y; })
                            

                let pathG:any = seletedCircleG.append("g")
                            .selectAll("path.link")
                            .data(organData.titleDatas)
                            .enter().append("path")
                            .attr("id", function(d:any) {return d.title.name})
                            .attr("class", "link")
                            .attr("d", rightAngleDiagonal())
                            .attr("fill", "none")
                            .attr("stroke", function(d:any) {return d.color})
                            .attr("stroke-width", "1.2px")
                            .attr("opacity", "0")
                            .attr("stroke-dasharray",function(d:any){
                                if(d.strokeDasharray){
                                    return d.strokeDasharray;
                                }else{
                                    return "0";
                                }
                            });

                if(isClickMainTitle){
                    mainTitleG.on("click")();
                }

                function mouseoveredWithOrganLabel(active:boolean ){
                    return function(this: any, event: any, d: any) {
                        activeNodesWithOrganLabel(this, d, active);
                    };
                }
            
                function activeNodesWithOrganLabel(node: any, d: any, active: boolean) {
                    if(active){
                        d3.select(node).attr("fill", d.color);
                    }else{
                        d3.select(node).attr("fill", "#000000");
                    }

                    d3.select(node).classed("label--active", active);
            
                    circleG.filter((d2:any) => (d.title.name === d2.title.name)).classed("link-circle--active", active);
                    pathG.filter((d2:any) => (d.title.name === d2.title.name)).classed("link--active", active);
                }

                function mouseClickOnMainLabel(){
                    return function(this: any, event: any, d: any) {
                        if(isSelectMainTitle){
                            pathG.attr("opacity", "0");
                        }else{
                            pathG.attr("opacity", "0.5");
                        }

                        isSelectMainTitle = !isSelectMainTitle;
                    }
                }

                function mouseoveredWithMainLabel(active:boolean ){
                    return function(this: any, event: any, d: any) {
                        if(isSelectMainTitle === false){
                            if(active){
                                pathG.attr("opacity", "0.5");
                            }else{
                                pathG.attr("opacity", "0");
                            }
                        }

                    };
                }

            }
        });
    }

    let plotMargins = {
        top: 35,
        bottom: 20,
        left: 5,
        right: 30,
        xorrectionX: -47,
        xorrectionY: 45,
        };

    const labelStartPosition:number = 280;

    // let humanWidth:number = width - plotMargins.left - plotMargins.right;
    // let humanHeight:number = height - plotMargins.top - plotMargins.bottom;

    // Basic the infomation of body parts for draw.
    // let defaultPositionOfBodyParts: BodyPartInterface[] = [
    //         { title:{name:'Frontal'},       Source2: 'frontal',   side:'NA', position: {male:{x:145,y:25},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Frontal'},       Source2: 'frontal',   side:'rt', position: {male:{x:141,y:25},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Frontal'},       Source2: 'frontal',   side:'lt', position: {male:{x:149,y:25},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Occiput'},       Source2: 'occiput',   side:'NA', position: {male:{x:145,y:22},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Occiput'},       Source2: 'occiput',   side:'rt', position: {male:{x:141,y:22},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Occiput'},       Source2: 'occiput',   side:'lt', position: {male:{x:149,y:22},female:{x:0,y:0}}, cellType: '', color: ''},

    //         { title:{name:'Rt. Eyebrow'},   Source2: 'eyebrow',   side:'rt', position: {male:{x:137,y:37},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Eyebrow'},   Source2: 'eyebrow',   side:'lt', position: {male:{x:154,y:37},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Eyelid'},    Source2: 'eyelid',    side:'rt', position: {male:{x:137,y:43},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Eyelid'},    Source2: 'eyelid',    side:'lt', position: {male:{x:154,y:43},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Temporal'},  Source2: 'temporal',  side:'rt', position: {male:{x:128,y:44},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. temporal'},  Source2: 'temporal',  side:'lt', position: {male:{x:162,y:44},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. EOM'},       Source2: 'EOM',       side:'rt', position: {male:{x:137,y:45},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. EOM'},       Source2: 'EOM',       side:'lt', position: {male:{x:154,y:45},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Cornea'},    Source2: 'cornea',    side:'rt', position: {male:{x:137,y:46},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Cornea'},    Source2: 'cornea',    side:'lt', position: {male:{x:154,y:46},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Nose'},      Source2: 'nose',      side:'rt', position: {male:{x:143,y:53},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Nose'},      Source2: 'nose',      side:'lt', position: {male:{x:147,y:53},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Mustache'},      Source2: 'mustache',  side:'NA', position: {male:{x:145,y:58},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Mustache'},      Source2: 'mustache',  side:'rt', position: {male:{x:143,y:58},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Mustache'},      Source2: 'mustache',  side:'lt', position: {male:{x:147,y:58},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Cheek'},     Source2: 'cheek',     side:'rt', position: {male:{x:134,y:54},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Cheek'},     Source2: 'cheek',     side:'lt', position: {male:{x:159,y:54},female:{x:0,y:0}}, cellType: '', color: ''},

    //         { title:{name:'Rt. Shoulder'},  Source2: 'shoulder',  side:'rt', position: {male:{x:95,y:105} ,female:{x:0,y:0}},  cellType: '', color: ''},
    //         { title:{name:'Lt. Shoulder'},  Source2: 'shoulder',  side:'lt', position: {male:{x:194,y:105},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Chest'},     Source2: 'chest',     side:'rt', position: {male:{x:122,y:130},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Chest'},     Source2: 'chest',     side:'lt', position: {male:{x:169,y:130},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Deltoid'},   Source2: 'deltoid',   side:'rt', position: {male:{x:85,y:135} ,female:{x:0,y:0}},  cellType: '', color: ''},
    //         { title:{name:'Lt. Deltoid'},   Source2: 'deltoid',   side:'lt', position: {male:{x:204,y:135},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Nipple'},    Source2: 'nipple',    side:'rt', position: {male:{x:120,y:136},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Nipple'},    Source2: 'nipple',    side:'lt', position: {male:{x:171,y:136},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Costal'},    Source2: 'costal',    side:'rt', position: {male:{x:120,y:160},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Costal'},    Source2: 'costal',    side:'lt', position: {male:{x:171,y:160},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Axilla'},    Source2: 'axilla',    side:'rt', position: {male:{x:103,y:161},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Axilla'},    Source2: 'axilla',    side:'lt', position: {male:{x:185,y:161},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Upper arm'}, Source2: 'upper_arm', side:'rt', position: {male:{x:85,y:162} ,female:{x:0,y:0}},  cellType: '', color: ''},
    //         { title:{name:'Lt. Upper arm'}, Source2: 'upper_arm', side:'lt', position: {male:{x:206,y:162},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Elbow'},     Source2: 'elbow',     side:'rt', position: {male:{x:80,y:180} ,female:{x:0,y:0}},  cellType: '', color: ''},
    //         { title:{name:'Lt. Elbow'},     Source2: 'elbow',     side:'lt', position: {male:{x:209,y:180},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Lower arm'}, Source2: 'lower_arm', side:'rt', position: {male:{x:70,y:205} ,female:{x:0,y:0}},  cellType: '', color: ''},
    //         { title:{name:'Lt. Lower arm'}, Source2: 'lower_arm', side:'lt', position: {male:{x:222,y:205},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Umbilicus'},     Source2: 'umbilicus', side:'NA', position: {male:{x:145,y:200},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Abdomen'},   Source2: 'abdomen',   side:'rt', position: {male:{x:127,y:201},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Abdomen'},   Source2: 'abdomen',   side:'lt', position: {male:{x:164,y:201},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Hand'},      Source2: 'hand',      side:'rt', position: {male:{x:49,y:235} ,female:{x:0,y:0}},  cellType: '', color: ''},
    //         { title:{name:'Lt. Hand'},      Source2: 'hand',      side:'lt', position: {male:{x:240,y:235},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Pubis'},         Source2: 'pubis',     side:'NA', position: {male:{x:145,y:240},female:{x:0,y:0}}, cellType: '', color: ''},

    //         {title:{name:'Rt. Hip'},       Source2: 'hip',        side:'rt', position: {male:{x:120,y:237},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Hip'},       Source2: 'hip',       side:'lt', position: {male:{x:169,y:237},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Thigh'},     Source2: 'thigh',     side:'rt', position: {male:{x:122,y:280},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Thigh'},     Source2: 'thigh',     side:'lt', position: {male:{x:169,y:280},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Knee'},      Source2: 'knee',      side:'rt', position: {male:{x:122,y:330},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Knee'},      Source2: 'knee',      side:'lt', position: {male:{x:169,y:330},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Leg'},       Source2: 'leg',       side:'rt', position: {male:{x:117,y:380},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Leg'},       Source2: 'leg',       side:'lt', position: {male:{x:174,y:380},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Rt. Foot'},      Source2: 'foot',      side:'rt', position: {male:{x:118,y:455},female:{x:0,y:0}}, cellType: '', color: ''},
    //         { title:{name:'Lt. Foot'},      Source2: 'foot',      side:'lt', position: {male:{x:175,y:455},female:{x:0,y:0}}, cellType: '', color: ''},
            
    //     ];

    let bodyPartsDic:any = {};
    let bodyPartDatas:BodyPartInterface[] = [];

    // bodyParts.forEach(bodyPart => {
    //     bodyPartsDic[bodyPart.Source2] = bodyPart;
    // });

    let colorCategoryValue:string[] = [];
    let colorCategoryMap:any = {};

    if(cloneData !== undefined){
        // clone data
        [colorCategoryValue, colorCategoryMap] = createDataByCloneData();
    }

    // color
    let color = d3.scaleOrdinal()
                    .domain(colorCategoryValue)
                    .range(d3.schemeCategory10)

    // scale
    let scale = d3.scaleLinear()
                    .domain([0, bodyPartDatas.length-1])    
                    .range([0, height - 20 ]);

    setLabelPointsAndColor(bodyPartDatas);

    function setLabelPointsAndColor(bodyPartDatas:any[]) {
        bodyPartDatas.sort(function (a, b) {

            if (a.position.y > b.position.y) {
                return 1;
            } else if (a.position.y < b.position.y) {
                return -1;
            } else if (a.position.x < b.position.x) {
                return 1;
            } else if (a.position.x > b.position.x) {
                return -1;
            } else if (a.title.name < b.title.name) {
                return -1;
            } else if (a.title.name > b.title.name) {
                return 1;
            }

            return 0;
        });

        for (let i = 0; i < bodyPartDatas.length; i++) {
            bodyPartDatas[i].title.x = labelStartPosition;
            bodyPartDatas[i].title.y = scale(i) + 10;

            if (bodyPartDatas[i].cellType !== undefined) {
                bodyPartDatas[i].color = color(bodyPartDatas[i].cellType);
            }
        }
    }

    function createDataByCloneData() {
        let colorCategoryValue:string[] = [];
        let colorCategoryMap:any = {};

        cloneData.forEach(data => {
            
            let bodyPartsKey:string = data.Cell_type + '_' + data.location_name;

            if (bodyPartsDic[bodyPartsKey] === undefined) {

                let tissueTitle: string = data.location_name; // + " (" + data.tissue_id + ")";

                let positionX: number = 0; 
                let positionY: number = 0;
                let strokeDasharray:any;

                for (let i = 0; i < cloneDetailData.length; i++) {
                    if (cloneDetailData[i].tissue_id === data.tissue_id && cloneDetailData[i].location_name === data.location_name) {
                        positionX = cloneDetailData[i].x;
                        positionY = cloneDetailData[i].y + plotMargins.xorrectionY;

                        if(cloneDetailData[i].location_name2){
                            tissueTitle = cloneDetailData[i].location_name2;
                        } else{
                            tissueTitle = cloneDetailData[i].location_name;
                        }

                        if(cloneDetailData[i].strokeDasharray){
                            strokeDasharray = cloneDetailData[i].strokeDasharray;
                        }
                        break;
                    }
                }

                let bodypartData: any = {
                    title: { name: tissueTitle },
                    Source2: data.Source_side,
                    side: data.Source2,
                    position: {
                            x: positionX,
                            y: positionY
                    },
                    cellType: data.Cell_type,
                    location_name: data.location_name,
                    tissueId: data.tissue_id,
                    color: 'black',
                };

                if(strokeDasharray){
                    bodypartData.strokeDasharray = strokeDasharray;
                }

                bodyPartsDic[bodyPartsKey] = bodypartData;
                bodyPartDatas.push(bodypartData);

                if (data.Cell_type !== undefined && colorCategoryMap[data.Cell_type] === undefined) {
                    colorCategoryMap[data.Cell_type] = data.Cell_type;
                    colorCategoryValue.push(data.Cell_type);
                }

            }

            let bodypartData: any = bodyPartsDic[bodyPartsKey];

            if (bodypartData.sampleData === undefined) {
                bodypartData.sampleData = [];
            }

            if (data.sample_id !== undefined) {
                bodypartData.sampleData.push({ sample_id: data.sample_id });
            }else{
                console.log(data);
            }

            if (bodypartData.position.x === undefined || bodypartData.position.x === 0) {
                console.log(data);    
            }

        });

        //console.log(bodyPartsDic);

        colorCategoryValue.sort();

        return [colorCategoryValue, colorCategoryMap]
    }

    // Draw path
    function rightAngleDiagonal() {
        let projection = function projection(d: any) { return [d.x, d.y]; }
        
        let path = function path(pathData: any) {
            return "M" + pathData[0] + ' ' + pathData[1] + " " + pathData[2];
        }
        
        function diagonal(diagonalPath: any, i: number) {
            let source = diagonalPath.position;
            let target = diagonalPath.title;
            let correctiony:number = source.y > target.y ? -2.3 : 2.3

            let pathData = [ {x: source.x, y: source.y + correctiony}, {x: source.x  + (( target.x - source.x) / 4) , y: target.y}, {x:target.x, y:target.y}];
            let pathData2 = pathData.map(projection);
            
            return path(pathData2)
        }
        
        diagonal.projection = function(x: any) {
            if (!arguments.length) return projection;
            projection = x;
            return diagonal;
        };
        
        diagonal.path = function(x: any) {
            if (!arguments.length) return path;
            path = x;
            return diagonal;
        };
        
        return diagonal;
    }

    function mouseovered(active:boolean ){
        return function(this: any, event: any, d: any) {
            activeNodes(this, d, active);
        };
    }

    // d3's .raise() reorders the DOM on every hover, which can make the browser
    // dispatch mouseout to a different (now-reordered) node than the one that
    // received mouseover, leaving part of the hover cascade stuck active.
    // Clearing stale (non-selected) hover state at the start of every hover
    // event keeps that from accumulating.
    function clearHoverOnly(){
        const svgSel:any = d3.select(svgRef.current);

        svgSel.selectAll(".label--active").each(function(this: any){
            const textNode = d3.select(this);
            if(!textNode.classed("selected")){
                textNode.classed("label--active", false).attr("fill", "#000;");
            }
        });

        svgSel.selectAll(".link-circle--active").each(function(this: any){
            const circleNode = d3.select(this);
            if(!circleNode.classed("selected")){
                circleNode.classed("link-circle--active", false);
            }
        });

        svgSel.selectAll(".link--active").each(function(this: any){
            const linkNode = d3.select(this);
            if(!linkNode.classed("selected")){
                linkNode.classed("link--active", false);
            }
        });
    }

    function activeNodes(node: any, d: any, active: boolean, selected?: boolean) {

        clearHoverOnly();

        if(selected){

            if(active){
                d3.select(node).attr("fill", d3.select(node).attr("fill2"));
            }else{
                d3.select(node).attr("fill", "#000;");
            }

            d3.select(node).classed("selected", active).classed("label--active", active);
            d3.select(d.circleNode).classed("selected", active).classed("link-circle--active", active).raise();
            do d3.select(d.linkNode).classed("selected", active).classed("link--active", active).raise();
            while (d = d.parent);       
        }else{

            if(!d3.select(node).classed("selected")){

                if(active){
                    d3.select(node).attr("fill", d3.select(node).attr("fill2"));
                }else{
                    d3.select(node).attr("fill", "#000;");
                }

                d3.select(node).classed("label--active", active);
            }

            if(!d3.select(d.circleNode).classed("selected")){
                d3.select(d.circleNode).classed("link-circle--active", active).raise();
            }
            do{ 
                if(!d3.select(d.linkNode).classed("selected")){
                    d3.select(d.linkNode).classed("link--active", active).raise();
                }
            }
            while (d = d.parent);
        }
    }

    function drawOrgan(svg: any, sex: string){
        let organDic:any = {};
        const organMainG = svg.append("g")
                          .attr('transform', `translate(${plotMargins.left + plotMargins.xorrectionX},${plotMargins.top}) `);

        const organLine:any ={ 
            male: [
            {   "id": "venacava",
                "name": "Vena cava",
                "paths": [{
                    "path":`M184.9,121.7c-0.1-1.6-1.1-1.6-1.7-4.1c0-0.2-0.1-0.3-0.5-3.4l0,0c0,0-1.7-0.6-3.1,0 c-0.2,0.1-0.5,0.2-0.7,0.3c-1.6,1.5,0.9,6.5,1.8,8.2c1.4,2.6,1.9,3.9,2.2,3.9C184,126.7,185,123.5,184.9,121.7z`,
                    "color": "#5B5B92",
                },{
                    "path":`M190.6,127c1.4,0.1,2.1,0.3,4,0.6c1,0.1,2.6,0.7,4.1-0.2c0.5-0.3,0.9-0.6,1.5-0.5c0.5,0.1,1,0.6,0.9,1.1  c-0.1,0.4-0.7,0.5-0.9,0.5c-0.6,0.2-0.9,0.2-1.7,0.3c-0.3,0.1-1,0.2-1,0.4c0,0.3,1.2,0.8,2.5,0.7c0.6,0,0.9-0.2,1.2,0  c0.3,0.3,0.5,0.9,0.2,1.2c-0.2,0.3-0.7,0.1-1.7,0c-1.8-0.3-2.7-0.6-3.5-0.3c-0.2,0.1-1.7-0.1-2.1,0.8c-0.1,0.4,0,1.4,0.5,3.2  c0.6,2,0.7,2.5,0.5,2.8c-0.4,0.5-1.3,0.6-2.1,0.2c-0.9-0.4-1.8-2-2-3c-0.6-4.2-2.8-6-1.4-7.7C190.1,126.8,190.4,127,190.6,127z`,
                    "color": "#5B5B92",
                }],
                "polygons": [{
                    "polygon":`184.1,152.4 184.5,164.5 188.1,164.5 188.1,155.5`,
                    "color": "#5B5B92",
                }],
                
            },
            {   "id": "aorta",
                "name": "Aorta",
                "paths": [{
                    "path":`M184.2,132.1c-1-2.7-1.5-4.1-1.4-5c0.3-2.2,2.1-2.6,2.1-4.7c0-0.5-0.2-1-0.7-2.4c-0.8-2.3-1.1-2.4-1.5-3.7    c-0.5-1.7-0.3-3.7,0.2-3.9c0.3-0.1,1.1,0.3,1.1,0.3l0,0c0,0,0.5,0.3,0.7,0.5c0.5,0.5,0,1.6-0.1,2.1c-0.7,2.5,1.9,6.1,2.7,5.8    c0.1,0,0.2-0.1,0.3-0.9c0.3-1.5,0.1-1.9,0.2-3c0.3-1.9,1.1-1.8,1.5-3.9c0-0.2,0.1-0.7,0.3-0.8c0.5-0.2,1.3,0.3,1.4,0.9    c0.1,0.6-0.3,1-0.7,1.4c-1.6,2.1-1.3,5.6-0.7,5.8c0.2,0.1,0.6-0.5,0.7-0.5c0.7-0.9,0-1.8,0-3.4c0-1.6,0.8-3.2,1.6-3.3    c0.3,0,0.7,0.2,0.8,0.5c0.2,0.6-0.3,1.1-0.9,2.2c-0.8,1.6-0.8,3.8,0,4.2c0,0,0,0,1,0.3l0,0c0,0,3,0.3,4,1.8    c1.1,1.7-0.1,5.2-1.7,5.6c-0.3,0.1-0.5,0-1.9-0.5c-3-0.8-3.4-0.7-3.5-0.5c-0.7,0.6-0.6,1.9-0.5,2.4c0.2,1.9,1.6,2.4,1.3,3.7    c-0.1,0.8-0.8,1.3-1,1.4c-1.3,0.9-2.9,0.7-3.9-0.1C185.1,134.4,184.9,133.9,184.2,132.1z`,
                    "color": "#842020"
                }],
                "polygons": [{
                    "polygon":`189.6,156 189.5,164.8 193.5,164.8 193.6,157.5`,
                    "color": "#842020",
                }],
            },
            {   "id": "kidney_rt",
                "name": "Rt. Kidney",
                "paths": [{
                    "path":`M180.4,194.4c-0.3-1.8-2.5-3.4-4.5-3.3c-1.6,0.1-3.5,1.3-5.3,3.5c-2,2.4-2.3,4.1-2.7,6.9 c-0.1,1.2-0.3,4.1,1.6,6.8c0.7,1.1,2.5,3.6,5.5,3.6c2.5-0.1,5-1.9,5.2-3.9c0.2-2.1-2.4-2.6-2.4-5.4c0-0.8,0.5-2.1,1.6-4.7 C180.2,195.4,180.5,195.1,180.4,194.4z`,
                    "color": "#581209",
                }],
            },
            {
                "id": "kidney_lt",
                "name": "Lt. kidney",
                "paths": [{
                    "path":`M194.5,207.2c0.5,1.7,2.9,3,4.9,2.6c1.6-0.3,3.3-1.8,4.8-4.2c1.6-2.7,1.7-4.4,1.7-7.2c0-1.2-0.3-4.1-2.5-6.6 c-0.9-0.9-3-3.3-5.9-2.8c-2.4,0.4-4.7,2.6-4.6,4.6c0.1,2.1,2.7,2.3,3.2,5c0.1,0.8-0.2,2.2-0.9,4.9 C194.5,206.1,194.2,206.6,194.5,207.2z`,
                    "color": "#581209",
                }],
            },
            {
                "id": "pancreas",
                "name": "Pancreas",
                "paths": [{
                    "path": `M199.6,192.8c-2.4,0.3-2.9,1.4-6.2,2.1c-0.1,0-1.6,0.1-4.6,0.2c-1.3,0.1-2.5,0.3-3.8,0.2s-2.1-0.3-3.1,0.2    c-0.9,0.4-1.4,1-1.5,1.1c-0.7,0.8-0.7,1.7-0.8,2.7c-0.1,1.4-0.2,2.2,0.3,2.9c0.8,1.2,2.3,1.4,2.7,1.4c0.5,0.1,1.8,0.2,2.7-0.6    c0.8-0.8,0.3-1.6,1-2.1c1-0.7,2.5,1.1,4.1,0.4c0.9-0.4,1-1.1,2.2-1.3c0.5-0.1,0.6,0,1.3-0.1c0.3-0.1,1.1-0.2,1.8-0.7    c0.4-0.3,0.7-0.6,1.4-1.4c0.6-0.6,0.5-0.6,1.1-1.2c0.5-0.5,0.6-0.6,1.6-1.5c1-1,1.1-1.2,1.1-1.4    C200.9,193.2,200.1,192.6,199.6,192.8z`,
                    "color": "#DDC5A4",
                }],
            },
            {  
                "id": "small_intestine",
                "name":"Small intestine",
                "paths": [{
                    "path": `M167.9,234.1c4.3,2.9,9.1,2.6,10.4,0.9c2.1-2.6-2.6-9.3-4.6-8.9c-1.5,0.3-1.1,4.9-1.8,5c-0.7,0-2.5-5,0-8.6
                            c0.3-0.5,1.5-2,3.5-2.6c0.7-0.2,1.6-0.4,2.3-0.1c1.4,0.6,1.5,2.8,1.6,4c0.1,1.3-0.1,2,0.1,2.1c0.7,0.2,2.1-3.6,3.9-3.6
                            c2.3,0,3.4,6.2,4.8,6.1c0.9-0.1,1.3-2.4,1.3-3.7c0-0.7,0.1-3.7-2.2-5.1c-1.1-0.7-2.4-0.7-3.6-0.8c-1.5,0-2.3,0.2-3.4,0.4
                            c-2.4,0.4-6.4,1.2-8.2-0.6c-1-1-1.4-2.8-0.7-3.7c0.5-0.5,1.4-0.7,3.4-1.2c0.2,0,0.5-0.1,0.9-0.1c0.5,0,1.3-0.1,1.8,0.1
                            c0.9,0.4,1.5,2,1,3c-0.7,1.4-2.7,1.6-4.1,1.3c-3.1-0.6-5.5-4.6-4.1-6.9c1-1.7,3.6-2,3.9-2c3.1-0.2,4,2.1,7.9,2.3
                            c2.2,0.1,2.2-0.5,4.1-0.4c4.3,0.4,7.2,4,7.4,3.8c0.2-0.2-3.5-3-2.9-4.8c0.5-1.2,3-1.8,3.9-1c1,0.8-0.9,2.7,0.1,4.2
                            c1,1.5,3.5,0.3,6.2,2.2c0.5,0.3,1.4,1.2,1.8,2.4c0.1,0.2,1,2.6-0.1,4.1c-1.6,1.9-6.4,1.4-7.1-0.2c-1.3-2.6,8-8.3,7-9.6
                            c-0.6-0.8-4,0.3-4.1-0.1c-0.1-0.3,1.9-0.9,3.6-3c0.9-1,0.9-1.5,0.9-1.7c-0.1-1-1.6-1.8-2.7-2c-1.3-0.2-2.3,0-5.7,1.5
                            c-4.2,1.8-4.1,1.9-5.1,2.1c-1.4,0.2-1.8,0-6.8-1.2c0,0-1.8-0.4-8.9-1.3c-1-0.1-2.6-0.3-3.4,0.5c-0.7,0.6-0.6,1.6-0.6,1.7
                            c0.2,2.4,5.2,3.5,13.6,6.9c4.7,2,7,3,8,4.4c2.1,3,0.6,5.8,3.4,8.3c1,0.8,2.9,2,2.5,3c-0.1,0.3-0.3,0.4-0.5,0.6
                            c-0.2,0.2-0.9,0.7-2.4,0.8c-4.4,0.2-7.3-1.7-7.3-1.7c-2.7-1.9-2.7-4.2-4.6-4.3c-1.5-0.1-1.9,1.4-3.5,1.3c-1.4-0.1-2.1-1.3-4.6-4.3
                            c-0.5-0.6-3.4-4-3.5-4c-0.2,0.1,2.7,9.8,10.1,12.4c6.6,2.2,14.6-2.1,17.3,1.3c0.5,0.6,1.1,1.9,2.9,2.6c1.3,0.6,3.1,0.8,3.5,0.2
                            c0.6-0.7-1.4-2-1.4-4.2c-0.1-2.2,1.7-4.6,2.7-4.4c1.3,0.2,2.4,4.4,1.1,5.2c-2.1,1.5-10.9-5.9-10.3-6.9c0.3-0.5,2.3,0.7,5.5,0.1
                            c2.2-0.4,4.7-1.7,4.6-2.7c-0.1-1.8-7.2-2-7.4-4c-0.1-1.2,2.3-1.6,4.3-3.7c3.5-3.8,3.3-10.7,0.9-11.7c-2.3-1-6.5,2.9-7.9,4.2`,
                        "color": "none",
                        "stroke":"#F4AFA1",
                        "strokeWidth":5,
                        "strokeMiterlimit":10,
                    },
                    {
                        "path": `M167.9,234.1c4.3,2.9,9.1,2.6,10.4,0.9c2.1-2.6-2.6-9.3-4.6-8.9c-1.5,0.3-1.1,4.9-1.8,5c-0.7,0-2.5-5,0-8.6
                                c0.3-0.5,1.5-2,3.5-2.6c0.7-0.2,1.6-0.4,2.3-0.1c1.4,0.6,1.5,2.8,1.6,4c0.1,1.3-0.1,2,0.1,2.1c0.7,0.2,2.1-3.6,3.9-3.6
                                c2.3,0,3.4,6.2,4.8,6.1c0.9-0.1,1.3-2.4,1.3-3.7c0-0.7,0.1-3.7-2.2-5.1c-1.1-0.7-2.4-0.7-3.6-0.8c-1.5,0-2.3,0.2-3.4,0.4
                                c-2.4,0.4-6.4,1.2-8.2-0.6c-1-1-1.4-2.8-0.7-3.7c0.5-0.5,1.4-0.7,3.4-1.2c0.2,0,0.5-0.1,0.9-0.1c0.5,0,1.3-0.1,1.8,0.1
                                c0.9,0.4,1.5,2,1,3c-0.7,1.4-2.7,1.6-4.1,1.3c-3.1-0.6-5.5-4.6-4.1-6.9c1-1.7,3.6-2,3.9-2c3.1-0.2,4,2.1,7.9,2.3
                                c2.2,0.1,2.2-0.5,4.1-0.4c4.3,0.4,7.2,4,7.4,3.8c0.2-0.2-3.5-3-2.9-4.8c0.5-1.2,3-1.8,3.9-1c1,0.8-0.9,2.7,0.1,4.2
                                c1,1.5,3.5,0.3,6.2,2.2c0.5,0.3,1.4,1.2,1.8,2.4c0.1,0.2,1,2.6-0.1,4.1c-1.6,1.9-6.4,1.4-7.1-0.2c-1.3-2.6,8-8.3,7-9.6
                                c-0.6-0.8-4,0.3-4.1-0.1c-0.1-0.3,1.9-0.9,3.6-3c0.9-1,0.9-1.5,0.9-1.7c-0.1-1-1.6-1.8-2.7-2c-1.3-0.2-2.3,0-5.7,1.5
                                c-4.2,1.8-4.1,1.9-5.1,2.1c-1.4,0.2-1.8,0-6.8-1.2c0,0-1.8-0.4-8.9-1.3c-1-0.1-2.6-0.3-3.4,0.5c-0.7,0.6-0.6,1.6-0.6,1.7
                                c0.2,2.4,5.2,3.5,13.6,6.9c4.7,2,7,3,8,4.4c2.1,3,0.6,5.8,3.4,8.3c1,0.8,2.9,2,2.5,3c-0.1,0.3-0.3,0.4-0.5,0.6
                                c-0.2,0.2-0.9,0.7-2.4,0.8c-4.4,0.2-7.3-1.7-7.3-1.7c-2.7-1.9-2.7-4.2-4.6-4.3c-1.5-0.1-1.9,1.4-3.5,1.3c-1.4-0.1-2.1-1.3-4.6-4.3
                                c-0.5-0.6-3.4-4-3.5-4c-0.2,0.1,2.7,9.8,10.1,12.4c6.6,2.2,14.6-2.1,17.3,1.3c0.5,0.6,1.1,1.9,2.9,2.6c1.3,0.6,3.1,0.8,3.5,0.2
                                c0.6-0.7-1.4-2-1.4-4.2c-0.1-2.2,1.7-4.6,2.7-4.4c1.3,0.2,2.4,4.4,1.1,5.2c-2.1,1.5-10.9-5.9-10.3-6.9c0.3-0.5,2.3,0.7,5.5,0.1
                                c2.2-0.4,4.7-1.7,4.6-2.7c-0.1-1.8-7.2-2-7.4-4c-0.1-1.2,2.3-1.6,4.3-3.7c3.5-3.8,3.3-10.7,0.9-11.7c-2.3-1-6.5,2.9-7.9,4.2`,
                        "color": "none",
                        "stroke":"#F6DEDA",
                        "strokeWidth":4,
                        "strokeMiterlimit":10,                       
                    }
                ],
            },
            {
                "id": "spleen",
                "name": "Spleen",
                "paths": [{
                    "path":`M208.6,171.9c-0.3,0.1-2.5,1.1-2.7,3c-0.1,1.2,0.6,2.5,1.7,3c1.2,0.6,1.9-0.3,3.7,0c0.3,0,2,0.4,3,1.7 c0.8,1,0.8,2.7,0.7,6c-0.1,2.1-0.3,4.7-0.3,4.7c0.8,1.6,2.5,2.4,4,2c1.7-0.4,2.1-3.2,2.3-5c0.3-1.9,1.1-7.7-3-12 C215.9,173,211.8,170.6,208.6,171.9z`,
                    "color": "#AC7DB4",
                }],
            },
            {
                "id": "stomach",
                "name": "Stomach",
                "paths": [{
                    "path":`M182.6,143.4c-1.2,5.9,0.5,12.5,1.3,15.2c1.1,3.4-0.1,0.4,2.2,6c1.8,4.6,5,6,6.3,8.2c1,1.6,2.7,1.9,3.2,2
                            c3.2,0.4,4.4-1.1,6.3-0.7c3.2,0.8,4.4,6.4,4.5,7.2c1.2,5.8-1.4,12.2-5.7,16.2c-0.8,0.7-5.9,5.4-12.3,4.7c-2-0.2-6-1.2-6.5-3.3
                            c-0.3-1.1,0.4-2.5-0.2-2.8c-0.5-0.3-1.3,0.7-2.2,0.3c-0.6-0.3-0.5-1-1.2-1.3c-0.7-0.4-1.9-0.1-2.2,0.5c-0.3,0.8,1.2,1.5,1.2,3.2
                            c0,0.1,0,1.3-0.8,1.8c-1,0.6-2.6-0.2-3.5-1.2c-1.7-2-1.1-6,1.2-8.2c2.1-1.9,4.9-1.7,5.5-1.7c1.1,0.1,2.2,0.6,4.5,1.5
                            c2.7,1.1,3,1.5,3.7,1.3c2.4-0.4,3.5-5,3.7-5.8c0.9-3.7,0.1-6.9-0.3-8.3c-1.8-6.4-5.1-9.9-7-13c-2.5-4-5-10.5-3.8-21.3L182.6,143.4
                            z`,
                    "color": "#F9DEBF",
                }],
            },
            { 
                "id": "large_intestine",
                "name": "Large intestine",
                "paths": [{
                    "path":`M168.4,206.1c-0.4,0.8-0.7,1.6-0.9,2.3c0.5,1.5,0.4,2.5,0.2,3.2c-0.1,0.4-0.6,1.7-0.6,1.7
                            c0.4,1.2,0.2,2.2,0,2.8c-0.2,0.8-0.5,1.2-0.4,1.8c0.1,0.8,0.7,1.1,1.2,1.7c1.5,1.9,0.7,4.5,0.8,4.5c0,0-0.1-1.3,0.2-1.3
                            c0.4-0.1,1.5,1.5,1.8,3.3c0.2,1.4-0.2,2.6-0.9,4.8c-0.2,0.7-0.5,1.4-0.9,2.3c-0.7,1.3-1.3,2.5-2.4,3.3c-1.3,1.1-4,2.3-6.5,1.5
                            c-2.9-1-3.5-4.2-3.5-4.3c-0.5-2.4,1.3-3.4,0.4-5.7c-0.4-0.7-0.8-1.3-0.8-2.3s0.5-1,0.6-2.2c0.2-1.5-0.6-1.8-0.2-3
                            c0.4-1,0.9-1.1,0.9-2c0-0.8-0.6-1-0.8-1.8c-0.4-1.5,1.2-2.1,1.2-4c0-1.3-0.6-1.1-0.6-2.3c0.1-1.9,1.8-2.4,1.5-4
                            c-0.1-0.9-0.6-0.9-0.8-2c-0.1-1,0.2-1.2,0.4-2.3c0.2-1.8-0.8-2.2-0.6-3.7c0.1-0.9,0.6-1.5,1.4-2.5c0.9-1.2,2.6-3.3,4.5-3.2
                            c1.3,0.1,1.3,1,3.8,1.8c0.8,0.3,1.2,0.3,2,0.7c1.1,0.5,1.1,0.9,2,1.3c1.3,0.7,1.8,0.2,2.9,0.8c1.1,0.6,0.8,1.1,1.8,1.5
                            c1.1,0.5,1.6-0.1,2.9,0.3c1.1,0.4,0.9,0.8,2,1.2c1.3,0.5,1.8-0.2,3.5,0.2c1.3,0.3,1.2,0.6,2.4,0.8c1.4,0.2,2.6-0.1,3.3-0.3
                            c1.4-0.4,1.4-0.7,2.6-0.8c1.2-0.1,1.3,0.2,2.1,0c1.1-0.2,1.2-0.8,2.6-1.5c0.6-0.3,0.8-0.3,2.1-0.8c2.6-1,4-1.5,4.7-2.3
                            c0.8-0.9,0.5-1.3,1.4-2.2c0.9-0.9,1.5-0.6,2.4-1.3c1.3-1.1,0.5-2,1.5-3.5c0.7-0.9,2.1-2.1,3.8-2c0.9,0.1,1.5,0.6,2.4,1.2
                            c0.6,0.5,1.9,1.5,2.4,3.3c0.2,1.2-0.1,2.2-0.6,3.7c-0.8,2.3-1.8,2.8-1.8,4.5c0,0.5,0.1,0.9,0,1.7c-0.1,0.9-0.4,1.1-0.6,2.2
                            c-0.1,0.3,0,0.3-0.2,2c-0.1,1.8-0.2,1.8-0.2,2.3c0,1,0.1,1.8,0.2,2.2c0.2,1.2,0.5,1.3,0.6,2.3c0.1,0.8,0,0.9,0,2.2
                            c0,1.5,0,2.3,0.2,3c0.5,1.6,1.3,1.7,1.4,3c0.1,1.1-0.5,1.2-0.4,2.3c0.1,1.4,0.9,1.6,1.2,3c0.2,1.1-0.2,1.1-0.4,2.8
                            c-0.1,2.1,0.5,2.3,0.2,3.8c-0.4,1.8-1.2,1.7-1.4,3.3c-0.4,2,0.9,2.5,0.4,3.8c-0.6,1.4-2.1,1.1-3.5,3c-1.1,1.5-0.6,2.2-1.5,2.8
                            c-1.2,0.7-2.2-0.2-4.4,0.3c-2,0.5-2,1.6-3.3,1.7c-1.9,0-2.4-1.9-4.4-2c-1.6,0-2.4,1.4-3.5,1c-1.2-0.3-0.8-1.7-2.4-2.5
                            c-0.9-0.5-2.1-0.6-2.6-0.2c-0.4,0.4,0.1,1.1,0.4,1.7c1.3,2.8-0.9,4.3-0.8,9c0.1,1.6,0.4,1.9,0.2,3.3c-0.1,1.2-0.4,3.3-2,4
                            c-0.6,0.3-1.6,0.4-2.1,0c-0.6-0.5-0.2-1.3-0.4-2.3c-0.2-1.7-1.8-2.1-2.7-3.7c-1.3-1.9,0-2.9-0.4-6.2c-0.4-3.5-1.9-3.4-2.4-6.7
                            c-0.2-1.2-0.9-6,2.7-8.7c0.2-0.2,3.2-2.2,5.9-1.5c2.4,0.6,2.8,2.8,5.7,3.2c1.1,0.1,1.6-0.1,2.4,0.3c1.3,0.7,0.9,2.2,2,2.5
                            c0.7,0.2,1.1-0.5,2.4-0.5c1.5,0,2.1,1,2.9,0.7c0.8-0.3,0.6-1.3,1.5-1.7c0.9-0.4,1.8,0.2,2.1-0.2c0.4-0.3-0.4-0.9-0.4-2
                            c0-0.9,0.5-0.9,0.6-2c0.1-1.2-0.4-1.3-0.2-2.3c0.2-1.1,0.9-1.2,0.9-2c0-1.1-1.3-1.2-1.5-2.5c-0.2-1,0.5-1.3,0.2-2.3
                            c-0.4-1.1-1.2-1-1.4-2c-0.2-1.2,0.8-1.6,0.6-2.8c-0.2-0.9-0.9-1-1.4-1.8c-0.6-1.1-0.1-2.2,0.4-3.8c0.8-2.9,0-2.8,0.8-6.5
                            c0.6-2.6,1.3-4.4,0.9-4.5c-0.5-0.1-1.4,2.6-3.9,3.2c-0.8,0.2-1.2,0-2.1,0.3c-1.3,0.5-1.4,1.2-2.4,1.3c-1.1,0.1-1.3-0.6-2.4-0.5
                            c-1.3,0.1-1.3,1.3-2.7,1.7c-1.3,0.3-1.6-0.4-3.3-0.2c-1.3,0.2-1.3,0.7-2.7,0.8c-1.2,0.2-1.3-0.2-2.9-0.2c-1.8,0-1.9,0.5-3.2,0.3
                            c-1.4-0.1-1.3-0.6-2.7-0.8c-2-0.3-2.6,0.6-3.8,0.2c-1.3-0.5-1.1-1.8-2.1-2c-0.8-0.1-1.2,0.5-2.4,0.7
                            C170.1,207,169.2,206.6,168.4,206.1z`,
                    "color": "#D99B97",
                }],               
            },
            {
                "id": "liver",
                "name": "Liver",
                "paths": [{
                    "path":`M182.6,168.9c-4.2-2.2-6.3-3.3-9.3-3.6c-1.8-0.2-6.1-0.4-10.5,1.9c-0.8,0.4-6.3,3.3-7.9,9.1
                            c-1,3.4-0.2,6.6,0.9,10.8c1,4.1,2.2,5.3,1.7,8.2c-0.3,2.2-1.4,4-0.6,4.8c0.6,0.4,1.5,0.2,2.6-0.1c4.2-1.4,5.5-3.5,9.3-5.8
                            c3.1-1.9,3.3-1.2,7-3.5c4.1-2.6,5-4.2,5.3-5.1c0.2-0.5,0.1-0.5,0.4-3.9c0.3-2.9,0.4-4.4,0.6-4.9c1-3.6,3.1-4.9,2.3-6.5
                            C183.9,169.6,183.4,169.4,182.6,168.9z`,
                    "color": "#A34C43",
                },{
                    "path":`M194.4,170.1c-6.5-0.1-6.9,0.5-7.5,0.8c-1.3,0.9-2.3,0.5-3.9,5.6c-1.4,4.9-1.1,8.5,0.1,10.4
                            c0.2,0.3-0.1-0.5,0.9-0.1c2.5,1,5.7-1.2,7.7-2.5c2.3-1.5,1.7-1.5,5-4.5c4.1-3.6,7.3-5,7-6.8c-0.1-1.1-1.4-1-2.1-1.5
                            C200.3,170.4,199.2,170.2,194.4,170.1z`,
                    "color": "#A34C43",
                },],               
            },
            {
                "id":"heart",
                "name":"Heart",
                "paths":[{
                    "path":`M178,148.5c-0.1,2.2,3.8,4.3,7,5.9c1.8,0.9,3.5,1.9,6.2,2.5c3.1,0.7,6.3,1.5,9.4-0.1c4.4-2.2,3.8-7,3.2-9.7
                            c-0.1-0.9,0.1-0.4-0.9-3.1c-1-2.3-2.3-2.5-5.7-4.4c-2.9-1.6-3.7-1.8-4.6-3.2c-1-1.8-0.6-2.9-1.5-3.4c-1.5-0.7-3.5,2.3-5.4,1.8
                            c-1.8-0.6-1.8-4.3-2.1-4.1c-0.3,0,0.7,4-0.1,8.5c-0.3,1.8-0.7,3.8-2.2,5.7C179.8,147.1,178.1,147.1,178,148.5z`,
                    "color": "#D66330",
                }],
            },
            { 
                "id":"lungs_rt",
                "name":"Rt. Lungs",
                "paths":[{
                    "path":`M171.7,101.5c-1.3-0.4-4.4-0.1-11,8.7c-6.3,8.6-9.4,16.3-9.7,17.1c-5.4,13.8-5.2,25.3-5.1,32.2
                            c0.1,6.7,1.1,12.9,2.7,13.2c0.8,0.1,1.2-1.6,4-4.3c2.3-2.3,4.4-3.6,5.6-4.3c3.5-2.1,4.3-1.5,6.7-3c3.9-2.4,3.5-4.6,7.4-8.3
                            c4.4-4.3,6.4-2.7,9.4-6c5-5.6,3.5-14.4,3.4-15.5c-1.1-5.9-3.8-5.5-5.6-13.7c-0.7-2.8-1.7-5.5-2.4-8.3c-0.4-1.7-0.8-3.6-2.4-5.4
                            C174.5,103.2,173.2,101.9,171.7,101.5z`,
                    "color": "#DDA1AA",
                }],
            },
            {   "id":"lungs_lt",
                "name":"Lt. Lungs",
                "paths":[{
                    "path":`M199.9,101.2c5-1.7,13.3,8.5,17.5,14.8c16.1,24.6,11.8,56.8,8.3,57.5c-1.1,0.1-1.5-2.8-5.6-5.4
                            c-3.4-2-4.4-0.9-7.8-3c-3.6-2.3-3.4-4.4-6.7-5.6c-2.8-1.1-4.3-0.1-5.1-1.3c-0.9-1.6,1.7-3.6,2.4-8.3c0.3-1.6,0.5-3.6-0.3-5.6
                            c-1.9-4.3-6.7-3.1-10.1-7.4c-2.8-3.6-2.8-9.1-1.6-12.8c1.3-4.3,1.2-4.2,2-8.3c0.8-3.9,1.7-5.5,3-9
                            C196,105.9,197.5,102,199.9,101.2z`,
                    "color": "#DDA1AA",
                }],
            },
            {
                "id":"blood",
                "name":"Blood",
                "paths":[{
                    "path":`M290.6,240c-1.4-2.1-3.7-3.6-6.1-4.3c-0.7-0.2-1.4-0.3-2-0.7c-0.2-0.2-0.4-0.4-0.7-0.5c-0.2-0.1-0.5,0-0.6-0.2  
                            c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.2-0.3-0.3-0.4-0.4c-1.2-0.7-2.4-1.5-3.6-2.2l-2.1-3.4c1.3,0,2.6,0,3.9,0c-1.6-1.3-3.2-2.6-4.9-3.8  
                            c-0.6-0.4-1.3-0.8-2-1l-7.4-11.9c3,1,5.7,2.7,8.3,4.4c-2.3-3.1-5.5-5.3-8.6-7.5c-1-0.7-1.9-1.3-2.9-2l-8.9-14.3c0.5,0,1,0.1,1.5,0.3  
                            c0.8,0.3,1.5,0.8,2.1,1.2c1.8,1.3,3.6,2.5,5.5,3.8c-0.8-1.6-2.3-2.7-3.9-3.3c-0.3-0.1-0.7-0.2-1-0.4c-0.5-0.3-0.8-0.7-1.2-1.1  
                            c-1.3-1.4-2.9-2.6-4.7-3.4l-6.4-10.3l3.1,10.3c-0.1-0.1-0.1-0.1-0.2-0.2l0.2,0.3l0.2,0.7l0.3,0.5c0.1,0.5,0,1.1,0,1.6  
                            c-0.2,2.9,0,5.9,0.7,8.7c0.2,0.8,0.4,1.6,0.2,2.4c0.4-2.3,0.5-4.7,0.3-7c0-0.4-0.1-0.8-0.2-1.1c-0.1-0.4-0.4-0.7-0.4-1.1  
                            c-0.1-0.6,0.2-1.1,0.6-1.5l6.6,10.6c0.2,1.1,0.1,2.2,0.2,3.3c0.1,3.5,1.8,6.7,1.9,10.2c-0.1-1.5-0.2-3.1-0.2-4.6  
                            c0.1-1.7,0.3-3.4,0.5-5l9.9,16c-0.4,2.4,0.1,4.8,0.7,7.2c0.4,1.8,0.8,3.6,1.2,5.5c0.2-0.8,0.2-1.7,0.2-2.5c-0.1-2.7-0.2-5.4-0.7-8.1  
                            l5.6,9c0,3.7,0,7.3,0.1,11c0,0.9,0.1,1.9,0.6,2.2c0.7-3.3,1-6.9,1.1-10.4l0.7-0.4c0.5,0,0.9,0,1.4,0.2c1.3,0.6,1.5,2.4,2.3,3.6  
                            c0.3,0.5,0.8,0.9,1.2,1.3c0.6,0.7,1.1,1.6,1.4,2.5c0.5-1.6-0.5-3.2-1.5-4.6c-1-1.4-2-2.8-3-4.1l0.1-0.1l-0.5-0.8  c3.1,0.4,5.6,2.4,8.2,4.1
                            C288,239,289.2,240,290.6,240z`,
                    "color": '#842020'

                }]
            },
         ],
         female: [
         {   "id": "venacava",
            "name": "Venacava",
            "paths": [{
                "path":`M190.1,131.4c-0.1-1.4-1-1.4-1.5-3.6c0-0.2-0.1-0.3-0.4-3l0,0c0,0-1.5-0.5-2.7,0c-0.2,0.1-0.4,0.2-0.6,0.3
                        c-1.4,1.3,0.8,5.7,1.6,7.2c1.2,2.3,1.7,3.4,1.9,3.4C189.3,135.8,190.2,133,190.1,131.4z`,
                "color": "#5B5B92",
            },{
                "path":`M195.3,136c1.4,0.1,2.1,0.3,4,0.6c1,0.1,2.6,0.7,4.1-0.2c0.5-0.3,0.9-0.6,1.5-0.5c0.5,0.1,1,0.6,0.9,1.1   c-0.1,0.4-0.7,0.5-0.9,0.5c-0.6,0.2-0.9,0.2-1.7,0.3c-0.3,0.1-1,0.2-1,0.4c0,0.3,1.2,0.8,2.5,0.7c0.6,0,0.9-0.2,1.2,0   c0.3,0.3,0.5,0.9,0.2,1.2c-0.2,0.3-0.7,0.1-1.7,0c-1.8-0.3-2.7-0.6-3.5-0.3c-0.2,0.1-1.7-0.1-2.1,0.8c-0.1,0.4,0,1.4,0.5,3.2   c0.6,2,0.7,2.5,0.5,2.8c-0.4,0.5-1.3,0.6-2.1,0.2c-0.9-0.4-1.8-2-2-3c-0.6-4.2-2.8-6-1.4-7.7C194.8,135.8,195.1,136,195.3,136z`,
                "color": "#5B5B92",
            }],
            "polygons": [{
                "polygon":`187.1,153.4 187.5,165.5 191.1,165.5 191.1,156.5`,
                "color": "#5B5B92",
            }],
            
        }, 
        {   "id": "aorta",
            "name": "Aorta",
            "paths": [{
                "path":`M189.5,140.5c-0.9-2.4-1.3-3.6-1.2-4.4c0.3-1.9,1.8-2.3,1.8-4.1c0-0.4-0.2-0.9-0.6-2.1c-0.7-2-1-2.1-1.3-3.2
                        c-0.4-1.5-0.3-3.2,0.2-3.4c0.3-0.1,1,0.3,1,0.3l0,0c0,0,0.4,0.3,0.6,0.4c0.4,0.4,0,1.4-0.1,1.8c-0.6,2.2,1.7,5.3,2.4,5.1
                        c0.1,0,0.2-0.1,0.3-0.8c0.3-1.3,0.1-1.7,0.2-2.6c0.3-1.7,1-1.6,1.3-3.4c0-0.2,0.1-0.6,0.3-0.7c0.4-0.2,1.1,0.3,1.2,0.8
                        c0.1,0.5-0.3,0.9-0.6,1.2c-1.4,1.8-1.1,4.9-0.6,5.1c0.2,0.1,0.5-0.4,0.6-0.4c0.6-0.8,0-1.6,0-3c0-1.4,0.7-2.8,1.4-2.9
                        c0.3,0,0.6,0.2,0.7,0.4c0.2,0.5-0.3,1-0.8,1.9c-0.7,1.4-0.7,3.3,0,3.7c0,0,0,0,0.9,0.3l0,0c0,0,2.6,0.3,3.5,1.6
                        c1,1.5-0.1,4.5-1.5,4.9c-0.3,0.1-0.4,0-1.7-0.4c-2.6-0.7-3-0.6-3.1-0.4c-0.6,0.5-0.5,1.7-0.4,2.1c0.2,1.7,1.4,2.1,1.1,3.2
                        c-0.1,0.7-0.7,1.1-0.9,1.2c-1.1,0.8-2.5,0.6-3.4-0.1C190.3,142.5,190.1,142.1,189.5,140.5z`,
                "color": "#842020"
            }],
            "polygons": [{
                "polygon":`192.6,157 192.5,165.8 196.5,165.8 196.6,158.5`,
                "color": "#842020",
            }],
        },
        {   "id": "kidney_rt",
            "name": "Rt. Kidney",
            "paths": [{
                "path":`M185.4,195.6c-0.3-1.8-2.5-3.4-4.5-3.3c-1.6,0.1-3.5,1.3-5.3,3.5c-2,2.4-2.3,4.1-2.7,6.9   c-0.1,1.2-0.3,4.1,1.6,6.8c0.7,1.1,2.5,3.6,5.5,3.6c2.5-0.1,5-1.9,5.2-3.9c0.2-2.1-2.4-2.6-2.4-5.4c0-0.8,0.5-2.1,1.6-4.7   C185.2,196.6,185.5,196.3,185.4,195.6z`,
                "color": "#581209",
            }],
        },
        {
            "id": "kidney_lt",
            "name": "Lt. kidney",
            "paths": [{
                "path":`M199.5,208.5c0.5,1.7,2.9,3,4.9,2.6c1.6-0.3,3.3-1.8,4.8-4.2c1.6-2.7,1.7-4.4,1.7-7.2c0-1.2-0.3-4.1-2.5-6.6   c-0.9-0.9-3-3.3-5.9-2.8c-2.4,0.4-4.7,2.6-4.6,4.6c0.1,2.1,2.7,2.3,3.2,5c0.1,0.8-0.2,2.2-0.9,4.9   C199.5,207.4,199.2,207.8,199.5,208.5z`,
                "color": "#581209",
            }],
        },
        {
            "id": "pancreas",
            "name": "Pancreas",
            "paths": [{
                "path": `M203.1,192c-2.4,0.3-2.9,1.4-6.2,2.1c-0.1,0-1.6,0.1-4.6,0.2c-1.3,0.1-2.5,0.3-3.8,0.2   c-1.3-0.1-2.1-0.3-3.1,0.2c-0.9,0.4-1.4,1-1.5,1.1c-0.7,0.8-0.7,1.7-0.8,2.7c-0.1,1.4-0.2,2.2,0.3,2.9c0.8,1.2,2.3,1.4,2.7,1.4   c0.5,0.1,1.8,0.2,2.7-0.6c0.8-0.8,0.3-1.6,1-2.1c1-0.7,2.5,1.1,4.1,0.4c0.9-0.4,1-1.1,2.2-1.3c0.5-0.1,0.6,0,1.3-0.1   c0.3-0.1,1.1-0.2,1.8-0.7c0.4-0.3,0.7-0.6,1.4-1.4c0.6-0.6,0.5-0.6,1.1-1.2c0.5-0.5,0.6-0.6,1.6-1.5c1-1,1.1-1.2,1.1-1.4   C204.4,192.5,203.6,191.9,203.1,192z`,
                "color": "#DDC5A4",
            }],
        },
        {  
            "id": "small_intestine",
            "name":"Small intestine",
            "paths": [{
                "path": `M174.6,235.2c3.8,2.8,8,2.5,9.1,0.9c1.8-2.5-2.3-8.9-4-8.5c-1.3,0.3-1,4.7-1.6,4.8c-0.6,0-2.2-4.8,0-8.2
                        c0.3-0.5,1.3-1.9,3.1-2.5c0.6-0.2,1.4-0.4,2-0.1c1.2,0.6,1.3,2.7,1.4,3.8c0.1,1.2-0.1,1.9,0.1,2c0.6,0.2,1.8-3.4,3.4-3.4
                        c2,0,3,5.9,4.2,5.8c0.8-0.1,1.1-2.3,1.1-3.5c0-0.7,0.1-3.5-1.9-4.9c-1-0.7-2.1-0.7-3.2-0.8c-1.3,0-2,0.2-3,0.4
                        c-2.1,0.4-5.6,1.1-7.2-0.6c-0.9-1-1.2-2.7-0.6-3.5c0.4-0.5,1.2-0.7,3-1.1c0.2,0,0.4-0.1,0.8-0.1c0.4,0,1.1-0.1,1.6,0.1
                        c0.8,0.4,1.3,1.9,0.9,2.9c-0.6,1.3-2.4,1.5-3.6,1.2c-2.7-0.6-4.8-4.4-3.6-6.6c0.9-1.6,3.2-1.9,3.4-1.9c2.7-0.2,3.5,2,6.9,2.2
                        c1.9,0.1,1.9-0.5,3.6-0.4c3.8,0.4,6.3,3.8,6.5,3.6c0.2-0.2-3.1-2.9-2.5-4.6c0.4-1.1,2.6-1.7,3.4-1c0.9,0.8-0.8,2.6,0.1,4
                        c0.9,1.4,3.1,0.3,5.4,2.1c0.4,0.3,1.2,1.1,1.6,2.3c0.1,0.2,0.9,2.5-0.1,3.9c-1.4,1.8-5.6,1.3-6.2-0.2c-1.1-2.5,7-7.9,6.1-9.2
                        c-0.5-0.8-3.5,0.3-3.6-0.1c-0.1-0.3,1.7-0.9,3.2-2.9c0.8-1,0.8-1.4,0.8-1.6c-0.1-1-1.4-1.7-2.4-1.9c-1.1-0.2-2,0-5,1.4
                        c-3.7,1.7-3.6,1.8-4.5,2c-1.2,0.2-1.6,0-6-1.1c0,0-1.6-0.4-7.8-1.2c-0.9-0.1-2.3-0.3-3,0.5c-0.6,0.6-0.5,1.5-0.5,1.6
                        c0.2,2.3,4.6,3.3,11.9,6.6c4.1,1.9,6.1,2.9,7,4.2c1.8,2.9,0.5,5.5,3,7.9c0.9,0.8,2.5,1.9,2.2,2.9c-0.1,0.3-0.3,0.4-0.4,0.6
                        c-0.2,0.2-0.8,0.7-2.1,0.8c-3.9,0.2-6.4-1.6-6.4-1.6c-2.4-1.8-2.4-4-4-4.1c-1.3-0.1-1.7,1.3-3.1,1.2c-1.2-0.1-1.8-1.2-4-4.1
                        c-0.4-0.6-3-3.8-3.1-3.8c-0.2,0.1,2.4,9.4,8.9,11.8c5.8,2.1,12.8-2,15.2,1.2c0.4,0.6,1,1.8,2.5,2.5c1.1,0.6,2.7,0.8,3.1,0.2
                        c0.5-0.7-1.2-1.9-1.2-4c-0.1-2.1,1.5-4.4,2.4-4.2c1.1,0.2,2.1,4.2,1,5c-1.8,1.4-9.6-5.6-9-6.6c0.3-0.5,2,0.7,4.8,0.1
                        c1.9-0.4,4.1-1.6,4-2.6c-0.1-1.7-6.3-1.9-6.5-3.8c-0.1-1.1,2-1.5,3.8-3.5c3.1-3.6,2.9-10.2,0.8-11.2c-2-1-5.7,2.8-6.9,4`,
                    "color": "none",
                    "stroke":"#F4AFA1",
                    "strokeWidth":5,
                    "strokeMiterlimit":10,
                },
                {
                    "path": `M174.6,235.2c3.8,2.8,8,2.5,9.1,0.9c1.8-2.5-2.3-8.9-4-8.5c-1.3,0.3-1,4.7-1.6,4.8c-0.6,0-2.2-4.8,0-8.2
                            c0.3-0.5,1.3-1.9,3.1-2.5c0.6-0.2,1.4-0.4,2-0.1c1.2,0.6,1.3,2.7,1.4,3.8c0.1,1.2-0.1,1.9,0.1,2c0.6,0.2,1.8-3.4,3.4-3.4
                            c2,0,3,5.9,4.2,5.8c0.8-0.1,1.1-2.3,1.1-3.5c0-0.7,0.1-3.5-1.9-4.9c-1-0.7-2.1-0.7-3.2-0.8c-1.3,0-2,0.2-3,0.4
                            c-2.1,0.4-5.6,1.1-7.2-0.6c-0.9-1-1.2-2.7-0.6-3.5c0.4-0.5,1.2-0.7,3-1.1c0.2,0,0.4-0.1,0.8-0.1c0.4,0,1.1-0.1,1.6,0.1
                            c0.8,0.4,1.3,1.9,0.9,2.9c-0.6,1.3-2.4,1.5-3.6,1.2c-2.7-0.6-4.8-4.4-3.6-6.6c0.9-1.6,3.2-1.9,3.4-1.9c2.7-0.2,3.5,2,6.9,2.2
                            c1.9,0.1,1.9-0.5,3.6-0.4c3.8,0.4,6.3,3.8,6.5,3.6c0.2-0.2-3.1-2.9-2.5-4.6c0.4-1.1,2.6-1.7,3.4-1c0.9,0.8-0.8,2.6,0.1,4
                            c0.9,1.4,3.1,0.3,5.4,2.1c0.4,0.3,1.2,1.1,1.6,2.3c0.1,0.2,0.9,2.5-0.1,3.9c-1.4,1.8-5.6,1.3-6.2-0.2c-1.1-2.5,7-7.9,6.1-9.2
                            c-0.5-0.8-3.5,0.3-3.6-0.1c-0.1-0.3,1.7-0.9,3.2-2.9c0.8-1,0.8-1.4,0.8-1.6c-0.1-1-1.4-1.7-2.4-1.9c-1.1-0.2-2,0-5,1.4
                            c-3.7,1.7-3.6,1.8-4.5,2c-1.2,0.2-1.6,0-6-1.1c0,0-1.6-0.4-7.8-1.2c-0.9-0.1-2.3-0.3-3,0.5c-0.6,0.6-0.5,1.5-0.5,1.6
                            c0.2,2.3,4.6,3.3,11.9,6.6c4.1,1.9,6.1,2.9,7,4.2c1.8,2.9,0.5,5.5,3,7.9c0.9,0.8,2.5,1.9,2.2,2.9c-0.1,0.3-0.3,0.4-0.4,0.6
                            c-0.2,0.2-0.8,0.7-2.1,0.8c-3.9,0.2-6.4-1.6-6.4-1.6c-2.4-1.8-2.4-4-4-4.1c-1.3-0.1-1.7,1.3-3.1,1.2c-1.2-0.1-1.8-1.2-4-4.1
                            c-0.4-0.6-3-3.8-3.1-3.8c-0.2,0.1,2.4,9.4,8.9,11.8c5.8,2.1,12.8-2,15.2,1.2c0.4,0.6,1,1.8,2.5,2.5c1.1,0.6,2.7,0.8,3.1,0.2
                            c0.5-0.7-1.2-1.9-1.2-4c-0.1-2.1,1.5-4.4,2.4-4.2c1.1,0.2,2.1,4.2,1,5c-1.8,1.4-9.6-5.6-9-6.6c0.3-0.5,2,0.7,4.8,0.1
                            c1.9-0.4,4.1-1.6,4-2.6c-0.1-1.7-6.3-1.9-6.5-3.8c-0.1-1.1,2-1.5,3.8-3.5c3.1-3.6,2.9-10.2,0.8-11.2c-2-1-5.7,2.8-6.9,4`,
                    "color": "none",
                    "stroke":"#F6DEDA",
                    "strokeWidth":4,
                    "strokeMiterlimit":10,                       
                },
            ],
        },
        {
            "id": "spleen",
            "name": "Spleen",
            "paths": [{
                "path":`M207.9,171.9c-0.3,0.1-2.5,1.1-2.7,3c-0.1,1.2,0.6,2.5,1.7,3c1.2,0.6,1.9-0.3,3.7,0c0.3,0,2,0.4,3,1.7   c0.8,1,0.8,2.7,0.7,6c-0.1,2.1-0.3,4.7-0.3,4.7c0.8,1.6,2.5,2.4,4,2c1.7-0.4,2.1-3.2,2.3-5c0.3-1.9,1.1-7.7-3-12   C215.1,173,211,170.6,207.9,171.9z`,
                "color": "#AC7DB4",
            }],
        },
        {
            "id": "stomach",
            "name": "Stomach",
            "paths": [{
                "path":`M189.1,143.2c-1.2,5.9,0.5,12.5,1.3,15.2c1.1,3.4-0.1,0.4,2.2,6c1.8,4.6,5,6,6.3,8.2c1,1.6,2.7,1.9,3.2,2
                        c3.2,0.4,4.4-1.1,6.3-0.7c3.2,0.8,4.4,6.4,4.5,7.2c1.2,5.8-1.4,12.2-5.7,16.2c-0.8,0.7-5.9,5.4-12.3,4.7c-2-0.2-6-1.2-6.5-3.3
                        c-0.3-1.1,0.4-2.5-0.2-2.8c-0.5-0.3-1.3,0.7-2.2,0.3c-0.6-0.3-0.5-1-1.2-1.3c-0.7-0.4-1.9-0.1-2.2,0.5c-0.3,0.8,1.2,1.5,1.2,3.2
                        c0,0.1,0,1.3-0.8,1.8c-1,0.6-2.6-0.2-3.5-1.2c-1.7-2-1.1-6,1.2-8.2c2.1-1.9,4.9-1.7,5.5-1.7c1.1,0.1,2.2,0.6,4.5,1.5
                        c2.7,1.1,3,1.5,3.7,1.3c2.4-0.4,3.5-5,3.7-5.8c0.9-3.7,0.1-6.9-0.3-8.3c-1.8-6.4-5.1-9.9-7-13c-2.5-4-5-10.5-3.8-21.3L189.1,143.2z`,
                "color": "#F9DEBF",
            }],
        },
        { 
            "id": "large_intestine",
            "name": "Large intestine",
            "paths": [{
                "path":`M175.6,205.6c-0.3,0.8-0.6,1.6-0.8,2.3c0.4,1.5,0.3,2.5,0.2,3.2c-0.1,0.4-0.5,1.7-0.5,1.7
                        c0.3,1.2,0.2,2.2,0,2.8c-0.2,0.8-0.4,1.2-0.3,1.8c0.1,0.8,0.6,1.1,1,1.7c1.3,1.9,0.6,4.5,0.7,4.5c0,0-0.1-1.3,0.2-1.3
                        c0.3-0.1,1.3,1.5,1.5,3.3c0.2,1.4-0.2,2.6-0.8,4.8c-0.2,0.7-0.4,1.4-0.8,2.3c-0.6,1.3-1.1,2.5-2,3.3c-1.1,1.1-3.4,2.3-5.5,1.5
                        c-2.5-1-3-4.2-3-4.3c-0.4-2.4,1.1-3.4,0.3-5.7c-0.3-0.7-0.7-1.3-0.7-2.3c0-1,0.4-1,0.5-2.2c0.2-1.5-0.5-1.8-0.2-3
                        c0.3-1,0.8-1.1,0.8-2c0-0.8-0.5-1-0.7-1.8c-0.3-1.5,1-2.1,1-4c0-1.3-0.5-1.1-0.5-2.3c0.1-1.9,1.5-2.4,1.3-4c-0.1-0.9-0.5-0.9-0.7-2
                        c-0.1-1,0.2-1.2,0.3-2.3c0.2-1.8-0.7-2.2-0.5-3.7c0.1-0.9,0.5-1.5,1.2-2.5c0.8-1.2,2.2-3.3,3.8-3.2c1.1,0.1,1.1,1,3.2,1.8
                        c0.7,0.3,1,0.3,1.7,0.7c0.9,0.5,0.9,0.9,1.7,1.3c1.1,0.7,1.5,0.2,2.5,0.8c0.9,0.6,0.7,1.1,1.5,1.5c0.9,0.5,1.4-0.1,2.5,0.3
                        c0.9,0.4,0.8,0.8,1.7,1.2c1.1,0.5,1.5-0.2,3,0.2c1.1,0.3,1,0.6,2,0.8c1.2,0.2,2.2-0.1,2.8-0.3c1.2-0.4,1.2-0.7,2.2-0.8
                        c1-0.1,1.1,0.2,1.8,0c0.9-0.2,1-0.8,2.2-1.5c0.5-0.3,0.7-0.3,1.8-0.8c2.2-1,3.4-1.5,4-2.3c0.7-0.9,0.4-1.3,1.2-2.2
                        c0.8-0.9,1.3-0.6,2-1.3c1.1-1.1,0.4-2,1.3-3.5c0.6-0.9,1.8-2.1,3.2-2c0.8,0.1,1.3,0.6,2,1.2c0.5,0.5,1.6,1.5,2,3.3
                        c0.2,1.2-0.1,2.2-0.5,3.7c-0.7,2.3-1.5,2.8-1.5,4.5c0,0.5,0.1,0.9,0,1.7c-0.1,0.9-0.3,1.1-0.5,2.2c-0.1,0.3,0,0.3-0.2,2
                        c-0.1,1.8-0.2,1.8-0.2,2.3c0,1,0.1,1.8,0.2,2.2c0.2,1.2,0.4,1.3,0.5,2.3c0.1,0.8,0,0.9,0,2.2c0,1.5,0,2.3,0.2,3
                        c0.4,1.6,1.1,1.7,1.2,3c0.1,1.1-0.4,1.2-0.3,2.3c0.1,1.4,0.8,1.6,1,3c0.2,1.1-0.2,1.1-0.3,2.8c-0.1,2.1,0.4,2.3,0.2,3.8
                        c-0.3,1.8-1,1.7-1.2,3.3c-0.3,2,0.8,2.5,0.3,3.8c-0.5,1.4-1.8,1.1-3,3c-0.9,1.5-0.5,2.2-1.3,2.8c-1,0.7-1.9-0.2-3.7,0.3
                        c-1.7,0.5-1.7,1.6-2.8,1.7c-1.6,0-2-1.9-3.7-2c-1.4,0-2,1.4-3,1c-1-0.3-0.7-1.7-2-2.5c-0.8-0.5-1.8-0.6-2.2-0.2
                        c-0.3,0.4,0.1,1.1,0.3,1.7c1.1,2.8-0.8,4.3-0.7,9c0.1,1.6,0.3,1.9,0.2,3.3c-0.1,1.2-0.3,3.3-1.7,4c-0.5,0.3-1.4,0.4-1.8,0
                        c-0.5-0.5-0.2-1.3-0.3-2.3c-0.2-1.7-1.5-2.1-2.3-3.7c-1.1-1.9,0-2.9-0.3-6.2c-0.3-3.5-1.6-3.4-2-6.7c-0.2-1.2-0.8-6,2.3-8.7
                        c0.2-0.2,2.7-2.2,5-1.5c2,0.6,2.4,2.8,4.8,3.2c0.9,0.1,1.4-0.1,2,0.3c1.1,0.7,0.8,2.2,1.7,2.5c0.6,0.2,0.9-0.5,2-0.5
                        c1.3,0,1.8,1,2.5,0.7c0.7-0.3,0.5-1.3,1.3-1.7c0.8-0.4,1.5,0.2,1.8-0.2c0.3-0.3-0.3-0.9-0.3-2c0-0.9,0.4-0.9,0.5-2
                        c0.1-1.2-0.3-1.3-0.2-2.3c0.2-1.1,0.8-1.2,0.8-2c0-1.1-1.1-1.2-1.3-2.5c-0.2-1,0.4-1.3,0.2-2.3c-0.3-1.1-1-1-1.2-2
                        c-0.2-1.2,0.7-1.6,0.5-2.8c-0.2-0.9-0.8-1-1.2-1.8c-0.5-1.1-0.1-2.2,0.3-3.8c0.7-2.9,0-2.8,0.7-6.5c0.5-2.6,1.1-4.4,0.8-4.5
                        c-0.4-0.1-1.2,2.6-3.3,3.2c-0.7,0.2-1,0-1.8,0.3c-1.1,0.5-1.2,1.2-2,1.3c-0.9,0.1-1.1-0.6-2-0.5c-1.1,0.1-1.1,1.3-2.3,1.7
                        c-1.1,0.3-1.4-0.4-2.8-0.2c-1.1,0.2-1.1,0.7-2.3,0.8c-1,0.2-1.1-0.2-2.5-0.2c-1.5,0-1.6,0.5-2.7,0.3c-1.2-0.1-1.1-0.6-2.3-0.8
                        c-1.7-0.3-2.2,0.6-3.2,0.2c-1.1-0.5-0.9-1.8-1.8-2c-0.7-0.1-1,0.5-2,0.7C177.1,206.5,176.3,206.1,175.6,205.6z`,
                "color": "#D99B97",
            }],               
        },
        {
            "id": "liver",
            "name": "Liver",
            "paths": [{
                "path":`M189.5,169.7c-3.8-2.2-5.7-3.3-8.4-3.6c-1.6-0.2-5.5-0.4-9.5,1.9c-0.7,0.4-5.7,3.3-7.2,9.1
                        c-0.9,3.4-0.2,6.6,0.8,10.8c0.9,4.1,2,5.3,1.5,8.2c-0.3,2.2-1.3,4-0.5,4.8c0.5,0.4,1.4,0.2,2.4-0.1c3.8-1.4,5-3.5,8.4-5.8
                        c2.8-1.9,3-1.2,6.4-3.5c3.7-2.6,4.5-4.2,4.8-5.1c0.2-0.5,0.1-0.5,0.4-3.9c0.3-2.9,0.4-4.4,0.5-4.9c0.9-3.6,2.8-4.9,2.1-6.5
                        C190.7,170.4,190.2,170.1,189.5,169.7z`,
                "color": "#A34C43",
            },{
                "path":`M200.2,170.9c-5.9-0.1-6.3,0.5-6.8,0.8c-1.2,0.9-2.1,0.5-3.5,5.6c-1.3,4.9-1,8.5,0.1,10.4
                        c0.2,0.3-0.1-0.5,0.8-0.1c2.3,1,5.2-1.2,7-2.5c2.1-1.5,1.5-1.5,4.5-4.5c3.7-3.6,6.6-5,6.4-6.8c-0.1-1.1-1.3-1-1.9-1.5
                        C205.6,171.2,204.6,171,200.2,170.9z`,
                "color": "#A34C43",
            },],               
        },
        {
            "id":"heart",
            "name":"Heart",
            "paths":[{
                "path":`M186,152.4c-0.1,1.5,2.6,2.9,4.8,4c1.2,0.6,2.4,1.3,4.2,1.7c2.1,0.5,4.3,1,6.4-0.1c3-1.5,2.6-4.8,2.2-6.6
                        c-0.1-0.6,0.1-0.3-0.6-2.1c-0.7-1.6-1.6-1.7-3.9-3c-2-1.1-2.5-1.2-3.1-2.2c-0.7-1.2-0.4-2-1-2.3c-1-0.5-2.4,1.6-3.7,1.2
                        c-1.2-0.4-1.2-2.9-1.4-2.8c-0.2,0,0.5,2.7-0.1,5.8c-0.2,1.2-0.5,2.6-1.5,3.9C187.2,151.5,186.1,151.5,186,152.4z`,
                "color": "#D66330",
            }],
        },
        { 
            "id":"lungs_rt",
            "name":"Rt. Lungs",
            "paths":[{
                "path":`M180.1,117.9c-1-0.3-3.3-0.1-8.2,6.5c-4.7,6.4-7,12.1-7.2,12.7c-4,10.3-3.9,18.8-3.8,24c0.1,5,0.8,9.6,2,9.8
                        c0.6,0.1,0.9-1.2,3-3.2c1.7-1.7,3.3-2.7,4.2-3.2c2.6-1.6,3.2-1.1,5-2.2c2.9-1.8,2.6-3.4,5.5-6.2c3.3-3.2,4.8-2,7-4.5
                        c3.7-4.2,2.6-10.7,2.5-11.5c-0.8-4.4-2.8-4.1-4.2-10.2c-0.5-2.1-1.3-4.1-1.8-6.2c-0.3-1.3-0.6-2.7-1.8-4
                        C182.2,119.2,181.2,118.2,180.1,117.9z`,
                "color": "#DDA1AA",
            }],
        },
        {   "id":"lungs_lt",
            "name":"Lt. Lungs",
            "paths":[{
                "path":`M201.1,117.7c3.7-1.3,9.9,6.3,13,11c12,18.3,8.8,42.3,6.2,42.8c-0.8,0.1-1.1-2.1-4.2-4
                        c-2.5-1.5-3.3-0.7-5.8-2.2c-2.7-1.7-2.5-3.3-5-4.2c-2.1-0.8-3.2-0.1-3.8-1c-0.7-1.2,1.3-2.7,1.8-6.2c0.2-1.2,0.4-2.7-0.2-4.2
                        c-1.4-3.2-5-2.3-7.5-5.5c-2.1-2.7-2.1-6.8-1.2-9.5c1-3.2,0.9-3.1,1.5-6.2c0.6-2.9,1.3-4.1,2.2-6.7
                        C198.2,121.2,199.3,118.3,201.1,117.7z`,
                "color": "#DDA1AA",
            }],
        },
        {
            "id":"uterus",
            "name":"Uterus",
            "paths":[
                {
                    "path":`M201.8,237.7`,
                    "color": "none",
                    "stroke":"#231F20",
                    "stroke-miterlimit":10
                },
                {
                    "path":`M191.7,238.1c2.9,0,6.5,1.4,6.6,2.8c0,0.8-1,1-1.3,2.5c-0.3,1.2,0.3,1.7,0.3,3c0.1,2.5-2,2.8-2.5,5.8
                    c-0.3,2.3,0.3,4.3,0.3,4.3c0.3,0.8,0.6,1.4,0.7,2.5c0.1,1-0.1,1.8-0.3,2.3h-7.5c-0.2-0.5-0.4-1.4-0.3-2.3c0.1-1.1,0.4-1.7,0.7-2.5
                    c0,0,0.7-2,0.3-4.3c-0.5-3.1-2.6-3.3-2.5-5.8c0.1-1.3,0.6-1.8,0.3-3c-0.4-1.5-1.4-1.7-1.3-2.5C185.2,239.5,188.8,238.1,191.7,238.1
                    z`,
                    "color":"#EFA8B5",
                },
                {
                    "path":`M185.4,240.7c-1.1-0.3-2.6-0.8-4.3-1.3c-2.1-0.7-3.1-1-4.2-1.5c-3.3-1.5-3.3-2.3-5-2.5 c-1.7-0.2-4.2,0.6-5,2.5c-0.9,2.2,0.9,4.6,1,4.7c0.6,0.7,1.2,1.1,1.7,1.3`,
                    "color": "none",
                    "stroke":"#EFA8B5",
                    "stroke-miterlimit":10
                },
                {
                    "path":`M198,240.7c1.1-0.3,2.6-0.8,4.3-1.3c2.1-0.7,3.1-1,4.2-1.5c3.3-1.5,3.3-2.3,5-2.5c1.7-0.2,4.2,0.6,5,2.5 c0.9,2.2-0.9,4.6-1,4.7c-0.6,0.7-1.2,1.1-1.7,1.3`,
                    "color": "none",
                    "stroke":"#EFA8B5",
                    "stroke-miterlimit":10
                }
            ],
        },
        {
            "id":"ovary",
            "name":"Ovary",
            ellipses:[
                {
                    "color":"#FCE5E1",
                    "cx":173.2,
                    "cy":244.4,
                    "rx":2.9,
                    "ry":1.8
                },
                {
                    "color":"#FCE5E1",
                    "cx":210,
                    "cy":244.1,
                    "rx":2.9,
                    "ry":1.8
                },               
            ]
        },
        {
            "id":"blood",
            "name":"Blood",
            "paths":[{// 290 240 614.4 271.5 
                "path":`M284,245.5c-1-1.6-2.6-2.8-4.4-3.3c-0.5-0.1-1-0.2-1.4-0.5c-0.2-0.1-0.3-0.3-0.5-0.4c-0.2,0-0.3,0-0.4-0.2  
                        c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.9-0.6-1.7-1.1-2.6-1.7l-1.5-2.6c0.9,0,1.9,0,2.8,0c-1.1-1-2.3-2-3.6-2.9  
                        c-0.4-0.3-0.9-0.6-1.4-0.7l-5.3-9c2.2,0.7,4.1,2,6,3.3c-1.6-2.3-3.9-4-6.2-5.6c-0.7-0.5-1.4-1-2.1-1.5l-6.4-10.8  
                        c0.4,0,0.7,0.1,1.1,0.2c0.6,0.2,1.1,0.6,1.5,0.9c1.3,1,2.6,1.9,3.9,2.9c-0.6-1.2-1.6-2.1-2.8-2.5c-0.2-0.1-0.5-0.2-0.7-0.3  
                        c-0.3-0.2-0.6-0.5-0.9-0.8c-1-1.1-2.1-1.9-3.4-2.6l-4.6-7.8l2.2,7.8c0,0-0.1-0.1-0.1-0.1l0.2,0.3l0.2,0.6l0.2,0.4c0,0.4,0,0.8,0,1.2  
                        c-0.1,2.2,0,4.5,0.5,6.6c0.1,0.6,0.3,1.2,0.2,1.8c0.3-1.8,0.3-3.6,0.2-5.3c0-0.3,0-0.6-0.1-0.9c-0.1-0.3-0.3-0.5-0.3-0.8  
                        c-0.1-0.4,0.2-0.8,0.4-1.2l4.8,8.1c0.2,0.8,0.1,1.7,0.1,2.5c0.1,2.6,1.3,5.1,1.4,7.7c-0.1-1.2-0.1-2.3-0.1-3.5  
                        c0-1.3,0.2-2.5,0.4-3.8l7.2,12.1c-0.3,1.8,0.1,3.6,0.5,5.4c0.3,1.4,0.6,2.8,0.8,4.1c0.2-0.6,0.1-1.3,0.1-1.9  
                        c-0.1-2.1-0.2-4.1-0.5-6.1l4,6.8c0,2.8,0,5.6,0.1,8.3c0,0.7,0.1,1.5,0.4,1.6c0.5-2.5,0.7-5.2,0.8-7.9l0.5-0.3c0.3,0,0.7,0,1,0.2  
                        c0.9,0.5,1.1,1.8,1.7,2.7c0.2,0.4,0.6,0.7,0.9,1c0.5,0.5,0.8,1.2,1,1.9c0.4-1.2-0.4-2.5-1.1-3.5c-0.7-1-1.4-2.1-2.2-3.1l0.1-0.1  
                        l-0.4-0.6c2.2,0.3,4,1.8,5.9,3.1
                        C282.1,245.8,283,244.5,284,245.5z`,
                "color": '#842020'
            }]
        },

        ]
    };
    
        const organLineArray:any[] = organLine[sex];

        organLineArray.forEach( organData =>{
            const organG = organMainG.append("g").attr("opacity", "0.3");;

            if(organData.paths){
                organG.append("g")
                      .selectAll("path")
                      .data(organData.paths)
                      .enter()
                      .append("path")
                      .attr("fill", function(d:any){return d.color;})
                      .attr("d", function(d:any){return d.path;})
                      .attr("stroke", function(d:any){return d.stroke;})
                      .attr("stroke-width", function(d:any){return d.strokeWidth;})
                      .attr("stroke-miterlimit", function(d:any){return d.strokeMiterlimit;})
            }

            if(organData.polygons){
                organG.append("g")
                      .selectAll("polygon")
                      .data(organData.polygons)
                      .enter()
                      .append("polygon")
                      .attr("fill", function(d:any){return d.color;})
                      .attr("points", function(d:any){return d.polygon;});
            }

            if(organData.ellipses){
                organG.append("g")
                      .selectAll("ellipse")
                      .data(organData.ellipses)
                      .enter()
                      .append("ellipse")
                      .attr("fill", function(d:any){return d.color;})
                      .attr("cx", function(d:any){return d.cx;})   
                      .attr("cy", function(d:any){return d.cy;})   
                      .attr("rx", function(d:any){return d.rx;})
                      .attr("ry", function(d:any){return d.ry;});   
            }

            organDic[organData.id] = organG;

         })

         return organDic;
    }


    useEffect(() => {
        const svg:d3.Selection<SVGGElement, any, any, any> = d3.select(svgRef.current)  
                                                                .attr('width', width)
                                                                .attr('height', height)
                                                                .attr('preserveAspectRatio', 'xMinYMid meet')
                                                                .attr('viewBox', '0 0 ' + 450 + ' ' + 588);
        // if(viewbox){
        //     svg.attr('viewBox', '0 0 ' + viewbox.width + ' ' + viewbox.height)
        // }else{
            
        // }                                                       

        // initialization
        svg.selectAll("g").remove();

        let bodyG = svg.append("g")
                       .attr('transform', `translate(${plotMargins.left + plotMargins.xorrectionX},${plotMargins.top}) `);

        // legend
        const legendG = svg.append("g")
                           .selectAll("g")
                           .data(color.domain())
                           .join("g")
                           .attr("transform", (d, i) => `translate(5,${10 + i * 10})`);
    
        legendG.append("rect")
          .attr("width",8)
          .attr("height", 8)
          .attr("fill", (d) => String(color(d)));
    
        legendG.append("text")
          .attr("x", 14)
          .attr("y", 1)
          .attr("dy", 6)
          .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
          .attr('font-size', '10px')
          .text(d => d);

        /////////////// 
        // male
        ///////////////
        const bodyLine:any = {
            male: `M203.8,71.4L203.8,71.4L203.8,71.4c-0.1,0.4-0.8,13.9-0.2,16.6c0.7,2.9,2.2,6,4.4,8.6
        c2.8,3.2,6.8,5.9,7.2,6.2c4.1,3.1,11.2,7.2,19.5,12.8c4.6,3.1,11.2,10.7,13,14.6c2.9,6.4,2.9,24.2,4.1,28
        c2.1,6.5,6.8,17.3,8.3,19.7c5.8,8.9,9.5,14,10.6,16.8c1.1,2.9,4.6,23,9.5,29.8c3.5,4.7,4.7,5.8,5,6.1l0.1,0.1
    M285.3,230.4L285.3,230.4c0.2,0.1,0.3,0.1,0.4,0.1c1.5,0.4,4.3,1,7.4,1.3c2.1,0.3,4,1.2,6.8,3.2
        c3.8,2.6,11.4,8,11.6,8.6c0.1,0.6-2.9,1.8-4.5,1.3c-2-0.7-9.6-3.5-10-3c-0.5,0.6,0.5,3.8,2.6,6.7c3.7,6.5,11.1,16.5,11.6,17.4
        c1,1.9,0.1,2.9-0.9,2.6c-3.3-2.7-15.5-15.6-16-14.8
    M186.2,261
    M76.6,241.1
    M171.9,71.8c-0.9,0.3-5.1-2.9-6.2-5.7c-0.5-1.3-1-4.2-0.9-5.3c0.1-1.3,0.6-2.6,1.4-3c0.5-0.3,2-0.8,2.2-1.1
        c0.4-0.6,0.5-12.9,2.2-18.1c0.3-1,2-4.1,3.7-5.7c1.4-1.4,5.7-4.2,7.2-4.6c1.4-0.4,6.7-0.5,9.1-0.3c2.6,0.3,4.9,1,5.9,1.9
        c2.4,1.2,5.6,3.8,6.2,4.8c0.9,1.3,2.7,5.9,3.3,8.3c1.3,5.4,0.1,14-0.2,15.3c0,0.1,2.1,0.2,2.4,0.3c0.8,0.2,2.6,3,2.4,4.8
        c-0.2,2.1-2.5,5.8-3.2,6.7c-1.5,1.6-2.4,1.9-3.6,1.3l0,0
    M171.9,71.8L171.9,71.8c0,0.1,0.3,14-0.8,18.2c-0.5,2-2.3,5.5-4.1,7.4c-3.8,4-16.8,11.6-21.9,14.9
        c-1.5,0.9-6.6,3.4-8.9,5.4c-1.2,1-5.7,5.6-7,7.7c-1.5,2.4-3.8,7.8-4.2,10.3c-0.7,4.5,0.5,15.6-0.2,18.5
        c-0.5,1.9-4.8,14.2-6.8,18.2c-2.8,5.5-7,10.6-9,14.7c-1,1.9-3.1,6.1-3.6,8.4c-0.3,1.1-1.2,6.4-2,9.1c-0.6,1.9-2.8,8.4-3.6,9.9
        c-0.7,1.5-7.4,13.4-7.4,13.4l0,0
    M92.4,227.9c-0.9,1.8-5.5,2.6-13.2,4c-1.3,0.3-9.4,7.1-11.5,8.1c-0.4,0.2-2.7,1.4-3,1.9
        c-0.4,0.6,0.2,1.7,1,2s3.8,0,5.2-0.4c1.3-0.4,3.4-2.1,4-2.2c0.2-0.1,0.8-0.1,1.7-0.1c0.1,0,1.4-0.2,1.3-0.2l0,0
        c0.2,1.3-0.5,3.4-0.5,3.8c-0.3,1.9-4.5,8.7-7.1,13.8c-1.3,2.6-5.2,8.6-5.8,10.5c-0.2,0.7,1.2,1.3,2.4,0.9c2.2-1,6.6-8.8,8.9-11.9
        c2.7-3.5,5.9-5.8,6-5.7c0.3,1-7.1,11.4-8,13c-1.4,2.3-3.8,6.6-4.1,8.2c-0.1,0.6,1.7,0.9,2.8,0.3c1.4-0.8,8.6-11.2,11.3-15.3
        c0.8-1.1,2.2-2.2,2.7-2.2c0.3,0.7-1.6,4.5-2.7,6.8c-2,4.1-4,11.4-3.7,11.8c0.7,0.5,2.5-0.8,3.8-2.9c0.3-0.5,4.2-8,5.7-10.4
        c1.8-2.8,3.1-3.9,3.2-4c0.4,0.3-3.9,11.9-3.6,13.7c0.1,0.4,1.1,0.5,1.4,0.3c1.8-1.4,7-15,10.8-21.9c0.3-0.6,4.5-9,6.3-11.9
        c2.9-4.6,12.9-16.2,14.8-19c2.7-3.8,12.4-23.5,13.2-25.3c1-2.2,3.3-8.7,4.1-10.3c2.1-4.4,6-9.1,6.3-9.5l0,0
        c0.4-0.2,4.4,8.1,5.5,10.4c0.4,1.3,1.8,6,1.8,10.2c0.1,6.7-1.9,27.3-5,47.8c-1,6.3-1,13.8-1,19c0,3.9-1.9,13.8-2.3,17.5
        c-0.3,3.7,1.2,13.4,1.6,19.2c0.4,5.9,1.4,18.9,1.8,22.3c0.7,5.4,3.9,18.3,3.8,22.6c-0.1,4.4-3.5,15-4.1,18.4
        c-0.8,4.6-0.7,18.7,0.1,24.6c2.3,16.6,6,30.1,6.9,35.4c0.9,6,0.8,14.9-0.1,25.3c-0.3,3.8-1.1,7.6-2.2,10.2
        c-0.8,1.9-8.4,16.7-8.4,19c0.1,1.7,1.6,5.4,3.3,6.4c1.3,0.8,7.9,1.1,9,1.5c2.9,1.1,5,1.8,7.1,2.2c1.8,0.4,4.9-0.6,6.1-2
        c1.1-1.5,2-5.5,1.8-10c-0.2-4.6,0.5-22.8,0.8-25.7c0.5-4.8,0.3-18.4,0-22.6c-0.4-6.3,0.6-18.8,1.6-23.9
        c0.4-2.5,4.5-22.2,4.5-24.5c0-4.4-1.8-16.8-1.9-18.8c-0.1-2.1,1.6-19.7,3.2-27.8c2.5-12.7,4.2-42.9,4.9-48.4
        c0.4-3.1,2.5-15.6,2.3-18.3l0,0c0.7,2.2,1.1,5,1.1,7.8c-0.1,5.2,1.3,18.3,1.9,21.8c1,5.1,1.9,16.7,1.9,26.1
        c0,5.8,5.3,29.5,5.7,32.7c0.3,2.2-0.2,18.9-0.4,24.8c-0.2,5.2,1,16.9,3.4,25.3c1.2,4,2.9,15.4,2.7,20.2
        c-0.1,3.8-1.5,12.6-1.5,14.4c0,6.5,0.7,21.9,0.7,29.6c0.3,3.6,1,11.7,1.7,13.1c0.3,0.4,2.2,2.9,2.8,3.2
        c2.4,1.1,14.8,1.6,15.5,1.5c1.5-0.2,6.1-3.7,6.8-4.8c0.5-1,1-5.6,0.6-7.3c-0.5-2.2-4.6-9-5.4-10.5c-1.2-2.6-2.3-6-2.9-9.2
        c-1.3-7.3-1.2-15-1.3-23.6c-0.1-7.7,2.1-17.8,2.6-22.3c0.3-2.9,4.1-23.1,4.3-27.2c0.1-4.1-3.2-24.3-3.4-26.8
        c-0.1-1.1-0.2-19.2,0.7-22.5c1.6-5.4,3.6-14.4,3.8-19.8c0.3-9.2,0.1-16.5,0.5-22.2c0.4-5.8-0.7-18.3-0.9-22
        c-0.3-6.3-1.5-18.2-1.9-25.4c-0.2-3.4-2.5-19.7-2.9-24.8c-0.6-7.1-0.4-19.2-0.9-22.7c-0.7-4.8-0.5-8.2,1.1-10.9
        c1.7-2.7,3.5-7.6,3.9-8.2c3.7,4.6,7.7,12.2,10.3,18.6c2.1,5.2,9.5,17.2,13.4,23.6c2.2,3.5,13.2,18.9,14.5,20.9
        c5.1,7.6,16.8,33.8,18.2,33.6c0.2-0.1,0.7-1.4,0.5-3.6c-0.1-1.8-1.3-5.7-1.9-9.2c0-0.4-0.2-0.9-0.2-1l1.2,0.7
        c0.1,0.3,5,7.8,6.9,10.9c1.8,2.8,4.3,5.5,5.1,5.7s1.5-1.1,1.2-2.3c-0.3-1.4-3.4-6.2-5.3-8.9c-1.3-2.2-2-4.6-1.7-5.1
        c1-0.4,12.4,13.7,14,14.6c1.1,0.5,2.1,0.1,2.2-0.7c0.1-0.8-1-3.5-3.4-6.3c-3.9-4.6-7.9-11.5-8.1-11.7c-0.2-0.3,0.1,0,0,0
    M92.4,227.9`,
            female:`M227.1,119.6c-0.5-0.2-7.8-3.5-11.7-6.2c-0.4-0.3-10.1-7.4-11.2-9.4c-0.5-1.1-1.1-3.2-1.2-4.5
			c-0.1-3.7-0.3-9.6,0.5-10.7c0.2-0.3,3-3.5,4-5.1c1.1-1.7,4-4.1,5.3-6.3c1.1-1.9,2-7.2,1.6-8.7c-0.4-1.7-2.5-2.6-3.5-2.3
			c0,0,0,0-0.1,0l0.1-0.3c0-0.1,0-0.4,0-0.7c0-4.5-1.6-17-2.5-19.2c-0.6-1.3-3.4-6.8-5.3-8.7c-2-2.1-5.7-3.3-7.2-3.7
			c-1.5-0.4-5.5-0.5-8.2-0.2c-2.4,0.3-5,1.4-5.9,2.1c-2,1.7-3.9,3.8-6.2,6.9c-1.6,2.1-2.5,4-3.1,6.6c-1.5,5.8-1.5,17-1.6,17.8
			l-1.3-1.1c-0.5-0.1-1.3,0.6-1.5,1.5c-0.2,0.9-0.6,4.4-0.2,6.1c0.4,1.6,2.8,5.9,3.1,6.2c0.1,0.1,2,1.2,2.2,1.7
			c0.6,1.2,2.2,3.7,3,5.1c0.4,0.6,2.7,2.7,2.8,3c0.5,1-0.1,10-0.5,11.4c-0.4,1.5-3.7,6.7-6.9,9.5c-2,1.7-6.3,4.7-7.9,5.9
			c-2.2,1.5-3.3,2-5,2.4
		M229.1,120.8
		M224.9,163c0.2,0.4,5.9,13.5,8.7,22.4c1.9,6.4,2.8,14,3.7,15.5c2.8,4.7,24,31.4,26.8,35.4
			c1,1.4,3.1,6.1,3.6,8.4c0.2,0.8,1.5,8,1.7,9.2c0.7,3.3,1.7,5.6,4.1,9.6c1.6,4.2,4.2,15.7,5.8,18c0.6,0.8,1.8,0.5,2-0.5
			c0.1-0.5-3.6-14.4-3.1-16c0.1,0.1,0.3,0.2,0.6,0.6c2.5,3.4,8.5,16.4,8.9,17.3c0.9,1.7,2.6,3.1,3,2.9c0.1-0.2,0.3-0.5,0.3-0.9
			c0-1.7-4.4-12.8-6.2-17.3c-0.7-1.8-0.2-3.2,0.2-3.1c1,0.4,5,7.8,11,18.7c0.8,1.4,2.5,2,3.1,1.4c0.4-0.6-2.3-6.6-3.5-9
			c-3.2-6.9-6.8-13.8-5.5-14c0.1,0,0.2,0,0.3,0c0.5,0.3,6.7,7.8,11,15.6c0.8,1.3,2.4,2.4,3,2.2c0.4-0.2,0.4-1.8-0.7-4.2
			c-0.2-0.5-5.1-10.1-6.8-13.7c-1.1-2.2-6.1-11.2-5.3-11.9c0.9,0.3,6.7,5.1,8.1,5.8c1.6,0.7,3.2,0.1,3.2-0.9
			c-0.1-0.7-9.9-9.9-11.5-11.3c-1.6-1.4-11.7-6.5-13.6-9.2c-0.6-0.9-8.6-16.8-8.8-17.2c-0.4-0.9-5.6-15.7-7.1-19.5
			c-1.5-3.9-6.4-10.2-7.5-11.7c-1-1.4-5.2-13.9-6.4-16.9c-2.1-4.8-6.5-16.6-6.8-22.3c0-1.1-0.5-10.4-1.5-13.6
			c-0.4-1.1-2.4-4.7-4.3-6.8c-2.3-2.6-6.6-5.4-8.4-6.1
		M114.3,242.1c-0.3,0.2-2.2,13.9-4,18c-1.4,3.1-2.8,7.6-4,10.7c-0.5,1.5-1.4,8.3-2,10.9
			c-0.5,1.7-2,3.1-2.5,2.8c-0.5-0.3-0.9-2.3-0.5-4.6c0.1-0.8,2.2-13.3,1.8-14.1c-0.8,0.3-2.3,3.7-3.7,8.1c-0.2,0.7-1.7,7.7-2.9,9.8
			c-1.2,2.1-2.8,3.1-3.2,2.5c-0.7-1.4,1.6-8.9,4.2-19.8c0.2-0.7,0.2-1.3,0.2-1.5c-0.5-0.3-2.4,2.4-4.2,5.7c-0.7,1.2-2.1,6.6-2.3,7.3
			c-1.2,3.6-2.8,6.3-3.6,7c-0.8,0.8-1.7,0.7-2,0.2c-0.5-1.2,3.3-11,5.2-17.4c1.6-4.3,1.3-5,1.1-5.1c-0.5-0.1-2.3,1.6-3.2,3.8
			c-0.2,0.6-3.3,6.3-4.4,8c-1.1,1.7-3.2,5.5-3.7,5.7c-0.7,0.1-1.1-1.9-0.4-3.9c1.8-4.9,11.4-25.7,11.3-25.7c-0.5-0.2-4.3,1.2-5,1.6
			c-1.6,1-5,3.5-6.5,2.9c-0.5-0.2-0.9-0.8-0.9-1.2c0-0.5,8.7-8.5,11.9-11.2c2.5-1.6,5.9-3.9,8.4-4.7c1.8-0.7,4.8-3.1,7-6.2
			c2.6-3.9,8.1-15.2,10.4-22.4c1.6-4.9,3-10.6,3.5-11.8c0.9-2.5,8-13.5,10.8-18.8c1.7-3.3,6.8-19.1,7.5-20.9
			c1.7-4.3,3-11.2,3.1-14.6c0-0.8,0.5-7.7,1.1-9.2c1-2.3,3-6.5,5-8.6c2.5-2.6,4.8-4.5,6.6-5.5c1.1-0.6,3.9-1,4.5-1.2
		M114.3,242.1c0.3-0.7,3.6-7.6,13-19.2c2.6-3.2,7.8-10.2,13.8-17.4c1.8-2.2,3.8-5.8,4.8-9.3
			c0.7-2.7,11.3-27.3,12.5-33.5c0,0,0-0.1,0-0.2
		M224.9,163c-0.1,0.2-1.1,9.4-2.3,14.9c-0.6,2.8-2.9,10.2-3.6,13c-1.3,4.9-1.9,9.8-1,13.7
			c0.7,2.7,5.7,13.7,7.5,20.1c1.8,6.7,4,13.6,5.9,20.8c1.7,6.8,3.2,17,3.2,23.3c-0.1,6.9-0.1,24.9-0.2,26.1
			c-0.1,1.7-1.5,16.2-3.7,27.7c-3.4,17.5-5.9,25.9-6.2,28.8c0,0.3-0.1,0.8-0.1,1.6
		M224.3,353c0,0-0.1,0.8,0,2.9c-0.3,3,1.6,18.8,1.9,21.6c0.6,7,0.3,15-0.9,22.7c-0.4,2.7-3.4,19.3-3.6,20.1
			c-1.6,7.1-2.1,13.7-2,24.5c0.1,6.9,0.9,13.7,2.7,21.8c1.4,6.2,6,16.7,5.8,18.2c-0.2,1-1.9,2.7-3.8,3.2c-0.9,0.2-14.5,1.8-15.2,1.7
			c-0.5-0.1-2.3-1.5-3.3-3.1c-1-1.7-1-8.9-1.8-20.1c-0.2-2.9,1.1-11.3,1.2-14.3c0-1.8,0.3-7.5,0.3-10.7
		M194,268.5
		M158.5,162.6l0.2,0.9c-0.1-0.1-0.1,0,1,8.3c1.4,11.3,5,26.6,5.2,29.1c0.1,2.4-3.8,12.4-5.7,17.6
			c-1,2.6-5.9,16.7-8.2,23.7c-1.1,3.5-2.6,18.1-2.7,18.7c-1,8.8,2,44.8,2.2,47.6c0.5,9.5,1.2,12.7,4.2,25.1
			c1.8,7.8,3.3,17.1,3.5,22.1c0.2,5.4-1.5,17.6-1.7,19.3c-0.6,4.5-0.6,8.2-0.1,12c1.9,14.2,5.8,38.6,6,39.9
			c0.3,2.8,0.5,9.9,0.7,11.4c0.5,2.5,1.5,7.6,1.1,10.5c-0.1,0.6-0.7,9.4-0.9,10.1c0,0.1-0.4,3.1-1.9,6.1
		M161.5,464.9c0,0,0,0.1,0,0.2
		M160.2,467.9
		M161.5,464.3
		M161.5,465.1c0,0.1-2.6,7.6-4.4,11.6
		M157.1,476.7c-0.5,0.7-1,3.4-0.8,5.1c0,0.1,0,0.1,0,0c-0.1,3.2,0.9,3.2,1.4,3.7c1.7,1.4,2.6,1.9,4.2,2
			c2,0,8,0,8.2,0.1
		M169.9,487.6
		M169.9,487.6c3.5,0.1,5.3-0.2,6.5-0.5c0.2,0,0.4-0.1,0.5-0.2
		M170.1,487.5
		M177,487.1
		M177.8,486.9
		M177,486.9l1.4-1.2c0-0.3,1.2-1.3,1.1-4.3
		M179.5,481.4
		M194,268.5
		M179.5,481.4l0.5-4.4l0,0c0-2.6,0.3-8.2,0.4-11.1c0.1-3.7-1.8-15.6-1.4-20.7c0,0-0.9-19.9-0.8-22.3
			c0.1-5.2,1.1-13.3,2.3-21.9c0.4-3.2,0.3-10.4,0.3-10.8c0.5-3.8,1.2-10.2,1-15.5c-0.2-3.6-1.2-9.6-1.2-10.4c0-1.1,1.3-8.4,1.4-11.3
			c0.1-3.7,0.2-8.5,0.3-8.6c0.3-2.1,4.2-25.5,4.3-26.8c0.1-1.5,0.7-33.8,0.7-34.4c0.1-1.5,1.6-19.3,1.6-19.4
			c0.3-0.4,4.8-0.1,5.3-0.1c-1.2,1.8,2.1,54.2,4.6,75.8c1.2,10.3,3.7,22.4,3.7,25.2c0.1,4.1-0.9,17.8-0.7,21.3
			c0.2,3.6,2.6,19.8,2.8,22c0.7,7.6,0.6,28.9,0.7,30.8c0,0.7,0.1,1.7,0.2,2.3c0,0.1,0,0.1,0,0.1`
        };

                      
        bodyG.append("path")
            .attr("fill", "none")
            .attr("stroke","#000000")
            .attr("stroke-width", "2")
            .attr("stroke-linecap", "round")
            .attr("stroke-linejoin", "round")
            .attr("d", bodyLine[sex])
            .attr("opacity", "0.61");

        /// organ
        if(initData.organ){
            organDic = drawOrgan(svg, sex);
        }

        /////////////////////////////
        //////////////////////////////
        //////////////////////////////

        // draw tick line     
        svg.append('g')
            .append('line')
            .attr('x1', labelStartPosition)
            .attr('y1', 10)
            .attr('x2', labelStartPosition)
            .attr('y2', height - 10)
            .attr("stroke", "#ddd");

        // // draw line from body part
        let link = svg.append("g")
                        .selectAll("path.link")
                        .data(bodyPartDatas)
                        .enter().append("path")
                        .each(function(d:any) { d.linkNode = this; })
                        .attr("class", "link")
                        .attr("d", rightAngleDiagonal())
                        .attr("fill", "none")
                        .attr("stroke", function(d:any) {return d.color})
                        .attr("stroke-width", "1.2px")
                        .attr("opacity", "0.5")
                        .attr("stroke-dasharray",function(d:any){
                            if(d.strokeDasharray){
                                return d.strokeDasharray;
                            }else{
                                return "0";
                            }
                        });

       // draw the circles of body position 
       svg.append("g")
       .selectAll("g.node")
       .data(bodyPartDatas)
       .enter().append("circle")
       .each(function(d:any) { d.circleNode = this; })
       .attr("stroke","#000000")
       .attr("stroke-width", "1px")
       .attr("fill", function(d:any) {return d.color})
       .attr("opacity", "0.5")
       .attr("r", 3)
       .attr("cx", function(d:any) { return d.position.x; })
       .attr("cy", function(d:any) { return d.position.y; });

        // // Write the names of body position
        let title = svg.append("g")
                         .selectAll("g.node")
                         .data(bodyPartDatas)
                         .enter().append("text")
                         .each(function(d:any) { d.textNode = this; })
                         .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                         .attr('font-size', '10px')
                         .attr('fill', '#000;')
                         .attr('fill2', function(d:any) {return d.color})
                         .attr("dx", 8)
                         .attr("dy", 3)
                         .text(function(d: any) {
                              return d.title.name + " (" + d.cellType + " " + d.sampleData.length + ")"; 
                            })
                         .attr("transform", function(d) { return "translate(" + labelStartPosition + "," + d.title.y + ")"; })
                         .on("mouseover", mouseovered(true))
                         .on("mouseout", mouseovered(false));

        bodyPartDatas.forEach(bodyPartData => {
            if(bodyPartData.sampleData === undefined){
                bodyPartData.sampleData = [];
            }

            let index = 0;

            svg.append("g")
                 .selectAll("g.node")
                 .data(bodyPartData.sampleData)
                 .enter().append("circle")
                 .each(function(d:any) { d.sampleCircleNode = this; })
                 .attr("stroke-width", "0px")
                 .style("fill", "black")
                 .attr("opacity", "0.5")
                 .attr("r", 3)
                 .attr("cx", function(d:any) { 
                     return labelStartPosition + bodyPartData.textNode.getBBox().width + 25 + (index++ * 7);
                  })
                 .attr("cy", function(d:any) {
                     if(bodyPartData.title.y !== undefined){
                      return bodyPartData.title.y; 
                     }else return 0;

                  });
                 
        })
    
        // // Draw the circles
        // let circlesG = bodyG.append("g");
//        bodyPart.cloneData

        // Safety net: if the pointer leaves the figure entirely without a
        // matching mouseout ever reaching every hovered node (see clearHoverOnly),
        // make sure nothing is left stuck highlighted.
        svg.on("mouseleave", clearHoverOnly);

    }, [bodyPartDatas, initData]);

    return (
        <React.Fragment>
            <svg ref={svgRef}>
            </svg>
        </React.Fragment>
    );
}

export default GiHuman;